import React, { useState, useEffect, useRef, useCallback } from 'react'
import TabSwtich from "../../../../Common/fTabSwitch";
import { SearchableSelect } from "../../../../Common/Class/Select/SearchableSelec2";
import axios, { get, post } from "../../../../../Model/Network/Config/Axios";
import { FloatInputButton, FunctionalInput } from "../../../../Common/fInputs";
import PhotoTile from "../../../../Common/fPhoto";
import Track from "../../../../Common/fTrack";
import Moment from "moment";
import { handleError, showToast } from "../../../../Common/fToast/ToastCallback";
import { SidePane } from "../../../../Common/fSidePane/RightPane";
import Invoice from "./fInvoice";
import Tds from './Tds';
import { Spinner } from '../../../../../Components/Common/fLoader'
import moment from 'moment';
import PODetails from '../../PoDetails'
import { Modal } from '../../../../Common/fModal/Modal';
import { numberWithCommas } from '../../../../../Utils/NumberToComma';
import { NormalTable } from '../../../../Tables/NormalTable/NormalTable';
import { KeyValue } from '../../../../Common/Components/KeyValue';
import { PageLoader } from '../../../../Common/Components/PageLoader';
import { ViewAttachment } from '../../../../Common/ViewAttachments';
import { SupportTicket } from '../../../../Common/SupportTicket';
import { useSelector } from 'react-redux';
import TwoBRecon from './2bRecon';
import { ViewLedger } from '../../../fSettlements/fSettlements/fVendorLedger/VendorLedger/Helper/ViewLedger';
import { Allocation } from '../../../../Common/Allocation';
import { Integration } from '../../../../Common/Integration';
import { DropdownModal } from '../../../../Common/fModal/DropdownModal';
import { getBaseUrl } from '../../../../../Model/Network/Config/DecentralizeWrapper';
import { Form } from '../../../../Common/Class/Form';
import IrnDetails from './IrnDetails';
import useDateFormat from '../../useDateFormat';
import { CostAllocation } from '../../Submit/MultiSubmitInvoice/CostAllocation';
import ToggleSwitch, { ToggleSwitch2 } from '../../../../Common/fSwitch';
import { MultipleAttachmentUploaderModal } from '../../../../Common/Class/FloatLabelInput/MultipleFileAlone';
import { PhotoName } from '../../../../Common/fPhoto/PhotoName';
import { FloatInput, FloatSelect } from '../../../../Common/Class/FloatLabelInput';
import { MultiSelect } from "react-multi-select-component";
import { FloatFile } from '../../../../Common/Class/FloatLabelInput/FloatFile';
import Attachments from '../../../../Common/Components/Attachments';
import FindMaster from '../../../../Common/Class/Form/Master';
import FloatFile2 from '../../../../Common/Class/FloatLabelInput/FloatFile2';
import { ReadOnly } from '../../../../Common/fCard/ButtonOutline/ReadOnly';
import Contract from '../Contract';
import _, { isArray } from 'lodash';
import BankAdd from '../BankAdd';
import { BAJAJ } from '../../../fSettlements/fReimbursements/Voucher/CompanyVoucher';
import CustomTags from '../../CustomTags/CustomTags';
import MultiFlags from "../../../../Common/MultiFlags";
import { hasExceeded180DaysFromFY, RCMHasExcedded60Days, MSMEInvoice45DaysExceed, MSMEInvoice15DaysExceed } from '../../../../../Utils/Utils';
import { StateButton } from '../../../../Common/fStateButton';
import { WalletRechargeRequest } from '../WalletRechargeRequest';
import {  checkRCMStatusonLineItem } from './checkRCMStatus';
import OcrDetails from './OcrDetails';
import { Form2 } from '../../../../Common/Class/Form2';
import { ViewOcrMapping } from '../ViewOcrMapping';
import { OcrTableContainer } from './OcrTableContainer';
import { Gin } from './Gin';
import { InvoiceCategoryForm } from './InvoiceCategoryForm';
import IMSDetails from './IMSDetails';
import { Notification } from '../../../../Common/Components/Workflow/CommonNotification';
import { useHistory, useLocation } from 'react-router-dom';
import { useVendorContactHook } from '../../../../../Utils/UseLdcHook';
import { PartialSettlements } from './PartialSettlements';
import { useWriteAccessConfig } from '../../../../Hooks/useWriteAccessConfig';
import LineItemsSelectModal from './LineItemsSelectModal';
import EditCostAllocation from '../../Submit/MultiSubmitInvoice/CostAllocation/EditCostAllocation';


export const NINJA = ['NJRT','NIJCART']

export default function India(props) {
	const HISTORY = useHistory();
	let { details, onReload, id, debitNote, debitNoteDetails ,enableAddLineItem} = props;
	let utilities=(props && props.utilities)?props.utilities:false;
	const fileExtensions = ['.pdf', '.csv', '.docx', 'png', '.jpg', '.jpeg', '.xls', '.xlsx'];
	const isHttpLink=(value) => {
		const pattern = /^(https?:\/\/)[\w.-]+(\.[a-zA-Z]{2,})(\/\S*)?$/;
		return pattern.test(value);
	}
	
	 // excludes ApprovedInvoiceForm on tag  on timeline status 
	const excludeStatus = ['REVERTED','HOLD','UNHOLD','DECLINED']
    const timelineLogStatus = ['HOLD','UNHOLD','REVERTED','COMPLETED','CANCELLED','DECLINED','SKIPPED',"DELEGATED"]
	const [lineItemForms,setLineItemForms] = useState({});
	const [showBulkUpdate,setShowBulkUpdate] = useState(false);

	const tenantList = ["bajajelec","BAJAJELECT"];
	const [getTab, setTab] = useState(1);
	const [untag,setUntag] = useState(false);
	const [getVendor, setVendor] = useState({});
	const [vendorAddress, setVendorAddress] = useState([]);
	const [vendorAddressFilter, setVendorAddressFilter] = useState([]);
	const [toggleAddress, setToggleAddress] = useState(undefined);
	const [toggleBillAddress, setToggleBillAddress] = useState(undefined);
	const [toggleShipAddress, setToggleShipAddress] = useState(undefined);
	const [selectedVendorAddress, setSelectedVendorAddress] = useState('');
	const [selectedBillAddress,setSelectedBillAddress] = useState({});
	const [selectedShipAddress,setSelectedShipAddress] = useState({});
	const [getVendors, setVendors] = useState([]);
	const [getOffices, setOffices] = useState([]);
	const [Settlements, setSettlements] = useState(undefined);
	const [partial,setPartial] = useState(false);
	const [recall,setRecall] = useState(false);
	const [advance,setAdvance] = useState(false);
	const [expandedTds,setExpandedTds] = useState(null);
	const [expandedIntegrationData,setExpandedIntegrationData] = useState(null);
	const [loading,setLoading]  = useState(false);
	const [attachmentMode,setAttachmentMode] = useState(false);
	const [recallPartial,setRecallPartial] = useState(false);
	const [allowTdsAtLineItem,setAllowTdsAtLineItem] = useState(true);
	const [allowTdsAtHeader,setAllowTdsAtHeader] = useState(true);
	const [decline,setDecline] = useState(false);
	const [buttonLoading,setButtonLoading] = useState(false)
	const [advanceSettlements,setAdvanceSettlements] = useState([]);
	const [enableEditCostAllocation,setEnableEditCostAllocation] = useState(false);
	const {
		gst2ASyncingForIrn,
		gst2bRecon,
		costAllocation,
		mandatoryCostAllocation,
		creditNote,
		debitNote:debitNotePlugin,
		hsnMandatorySingleLineInvoice,
		tdsAtLineItem,
		budgetingV2,
		tdsAtLineItemInContract,
		tdsSlabMandatory,
		costAllocationOnBaseAmount,
		paymentAdviceCopy,
		walletRechargeRequest,
		restrictCnBeforeGrnSync,
		costAllocationOnNetPayableAmount,
		tdsAtLineItemAutomation,
		entityHierarchy,
		enableGin,
		ginInvoiceTagging,
		multipleDepositTypePerContractItem,
		partialSettlementRequestFlow,
		mandatoryCostAllocationAtTaxationApproval,
		partialPaymentPriorFinanceApproval,
		invoiceCreditNoteKnockoffAtSettlement
	} = useSelector(state=>state.auth.config.plugins);
	const [enableCostAllocation,setEnableCostAllocation] = useState(false);
	const [lineItemsSelectModal,setLineItemsSelectModal] = useState(false);
	const [repost,setRepost] = useState(false);
	const [allocationType,setAllocationType]= useState(undefined);
	const [invoices,setInvoices] = useState([]);
	const [btnloading,setBtnLoading] = useState(false);
	const [ledger,setLedger] = useState(undefined);
	const [InvoiceForm,setInvoiceForm] = useState([]);
	const [InvoiceFormOriginal,setInvoiceFormOriginal] = useState([]);
	const [LineItemForm,setLineItemForm] = useState([]);
	const [prefill,setPrefill]=useState();
	const [customFlags,setCustomFlags] = useState([])
	const [allIndependentCN,setAllIndependentCN] = useState();
	const [vendorDetails,setVendorDetails] = useState(undefined);
	const [master,setMaster] = useState({
		bill_to:details.address.title
	});
	const [masterLI,setMasterLI] = useState({
			bill_to:details.address.title
	});
	const [tags1,setTags1] = useState(details && details.tags ? details.tags : {});
	const [tags2,setTags2] = useState({});
	const [withdraw,setWithdraw] = useState(undefined);
	const {tenant} = useSelector(state=>state.auth.config)
	const config = useSelector(state=>state.auth.config);
	let exclude=(tenant==="DEZ")
	const disableUpdate = tenantList.includes(tenant)
	const [vendorStatus, setVendorStatus] = useState(undefined);
	let COSTALLOCATION = useRef();
	let TAXATION_CATEGORY_FORM = useRef();

	let { status } = details;
	let FORM = useRef();
	let CUSTOMFORM = useRef([]);
	let settlementFormate = useDateFormat("DD-MM-YYYY");

	let po = props.details.po && props.details.po.poId;
	let REMARKS = useRef(), REMARKS1 = useRef(),WITHDRAW_REMARK= useRef() ,AMOUNT = useRef(), REMARK = useRef(), ALLOCATION = useRef(), REMARK2 = useRef();

	let { isRcm} = typeof details.content === 'string' ? JSON.parse(details.content) : details.content;
	const [rcm,setRcm] = useState(isRcm || details.invoice.rcInvoice || (details && details.tags && details.tags.rcm && details.tags.rcm==="true"));
	const [activeRooms,setActiveRooms] = useState([]);
    const [creditNotes,setCreditNotes] = useState([]);
    const [debitNotes,setDebitNote] = useState([]);
	const [grn,setGrn] = useState([]);
	const [customTags,setCustomTags] = useState({});
    const [invoicePreview,setInvoicePreview] = useState(false)
	const [show,setShow]=useState(false);
	const {isSuper,name} = useSelector(state=>state.auth.config); 
	const [categoryMapping,setCategoryMapping] = useState({});
	const [revertBack,setRevertBack] = useState(undefined);
	const REVERT_REMARK=useRef(),APPROVER=useRef();
	const [approvalsList,setApprovalsList] = useState([]);
	const [tdsSlabs,setTdsSlabs] = useState([]);
	const [submittingForm,setSubmittingForm] = useState(false);
	const [ocrView,setViewOcr] = useState(undefined);
	const [categoryFormMap,setCategoryFormMap] = useState({});
	const [categoryForm,setCategoryForm] = useState([]);
	const [invoiceRoundOfAmountLimit,setInvoiceRoundOfAmountLimit] = useState(1);
	const [dependentField,setDependentField] = useState({});
	const [approveDiscountingModal, setApproveDiscountingModal] = useState(null);
	const [declineDiscountingModal, setDeclineDiscountingModal] = useState(null);
	const [withholdGstModal, setWithholdGstModal] = useState(false);
	const [partialPaymentModal, setPartialPaymentModal] = useState(false);
	const PARTIAL_REMARK=useRef(),PARTIAL_AMOUNT=useRef();
	const dueDate = props && props.details && props.details.dueOn 
    const { tdsCertificates } = useVendorContactHook(props.details && props.details.vendor && props.details.vendor.id);
	const [showDecline,setShowDecline] = useState(false);
	const location=useLocation();
	const {allowAsnInvoiceDecline} = useSelector(state=>state.auth.config)

	const writeAccess = useWriteAccessConfig();  

    const writeAccessTaxation =  ['ANRCK','ANAROCK','MOGLIXUAT'].includes(tenant) ? (isSuper || (writeAccess && writeAccess['Taxation Stage'])) : true;

	const pathname=location.pathname;

  const BAJAJ_ZRNT_CATEGORY = 4614;
  const BAJAJ_ZRNT_CATEGORY_PROD = 5214;

  useEffect(()=>{
	if(lineItemForms && Object.keys(lineItemForms).length){
		for(let key in lineItemForms){
			if(lineItemForms[key] && lineItemForms[key].forms && lineItemForms[key].forms.length){
				setShowBulkUpdate(true);
				break;
			}
		}
	}
	else{
		setShowBulkUpdate(false);
	}
  },[lineItemForms])

  const checkForHoldRemarks = (index) => {
	// hold remarks will come in the previous node data
	let holdRemarks = "";
	if(index-1>=0){
		let node = (details.timelines[index-1].data && details.timelines[index-1].data.length) ? details.timelines[index-1].data.find(item => item.key === 'holdRemarks') : undefined;
		if(node && node.value){
			holdRemarks = node.value;
		}
	}
	if(holdRemarks){
		return (
			<div style={{ marginTop: '5px' }}>Hold Remarks: {holdRemarks}</div>
		)
	}
	else{
		return <></>
	}
  }

  const isOwnerAdmin = () =>{
	let type="";
	let adminName="";
	if(details && details.owner && details.owner.values && details.owner.values.length){
		for(let i=0;i<details.owner.values.length;i++){
			if(details.owner.values[i].key === 'Type'){
				type=details.owner.values[i].value;
			}
			else if(details.owner.values[i].key === 'Name'){
				adminName=details.owner.values[i].value;
			}
		}
	}
	if(type==="ADMIN" && adminName===name){
		return true;
	}
	return false;
  }

  const approvalStatus= (status,bothShow=false) =>{
	   const showTenantOnlyAtTaxation = ['ANRCK','ANAROCK','MOGLIXUAT']
	     if(showTenantOnlyAtTaxation.includes(tenant) && !bothShow){
		  return status === 'TAXATION_APPROVAL'
	   }
		if(status === 'APPROVAL'){
			return true
		}
		else if(status === 'TAXATION_APPROVAL'){
			return true
		}
		if(status === 'DRAFT' && isOwnerAdmin()){
			return true;
		}
		return false
  }

	const skipApprovalForm = () => {
		const showTenantOnlyAtTaxation = ['ANRCK', 'ANAROCK', 'MOGLIXUAT']
		return (details.status === 'APPROVAL') && showTenantOnlyAtTaxation.includes(tenant)
	}

	const checkGstAtLineItem = () => {
		let flag = true;
		if(details && details.invoice && details.invoice.items && details.invoice.items.length > 0){
			for(let i=0;i<details.invoice.items.length;i++){
				if(!details.invoice.items[i].taxSlab){
					flag = false;
					break;
				}
			}
		}
		return flag;
	}

	useEffect(()=>{
		//invoice -> asn -> ibd -> allowAsnInvoiceDecline -> show decline option at all stages for finance admin with access
		//invoice -> asn -> ibd -> !allowAsnInvoiceDecline -> no decline option
		//invoice -> asn -> no ibd -> no decline option
		//invoice -> no asn -> old flow

		let {details} = props;
		let flag=false;
		if(details && details.asn && details.asn.id && (tenant === 'bajajelec' || tenant === 'BAJAJELECT')){
			get(`vendor/procurement/asn/getDetails/${details.asn.id}`,(e,r)=>{
				if(r && r.data && r.data.length){
					for(let i=0;i<r.data.length;i++){
						if(r.data[i].key && r.data[i].key === 'ibd_no'){
							flag=true;
							break;
						}
					}
					if(flag && (allowAsnInvoiceDecline || isSuper)){
						setShowDecline("all_stages"); //asn + ibd + allowAsnInvoiceDecline
					}
					else{
						setShowDecline(false); //asn + (no ibd or !allowAsnInvoiceDecline)
					}
				}
				else if(e){
					setShowDecline(false); //asn + no ibd
					handleError(e);
				}
			})
		}
		else{
			setShowDecline("approval"); //old flow -> show decline option at approval
		}
	},[])

	useEffect(()=>{
		if(Settlements && Settlements.advances && Settlements.advances.length){
			let obj={};
			for(let i=0;i<Settlements.advances.length;i++){
				if(Settlements.advances[i] && Settlements.advances[i].ledgerId){
					obj[Settlements.advances[i].ledgerId] = {...Settlements.advances[i]};
				}
			}
			if(details && details.invoice && details.invoice.ledgers && details.invoice.ledgers.length){
				for(let i=0;i<details.invoice.ledgers.length;i++){
					if(details.invoice.ledgers[i] && details.invoice.ledgers[i].ledgerId && (details.invoice.ledgers[i].ledgerId in obj)){
						obj[details.invoice.ledgers[i].ledgerId] = {...obj[details.invoice.ledgers[i].ledgerId],taggedByEmployee:true};
					}
					else{
						obj[details.invoice.ledgers[i].ledgerId] = {...details.invoice.ledgers[i],taggedByEmployee:true};
					}
				}
			}
			let arr=[];
			for(let key in obj){
				arr.push(obj[key]);
			}
			setAdvanceSettlements(arr);
		}
	},[Settlements,details])


	useEffect(()=>{
		if(details && details.tags && Object.keys(details.tags).length){
			let obj1={};
			let obj2={}

			Object.keys(details.tags).forEach((key)=>{
				if(key && key.startsWith('key')){
					let num=key.slice(3);
					let valNode="value"+num;
					if(valNode in details.tags){
						obj2[details.tags[key]] = details.tags[valNode];
					}
				}
				else if(key && key.startsWith('value')){
					let num=key.slice(5);
					let keyNode="key"+num;
					if(keyNode in details.tags){
						obj2[details.tags[keyNode]] = details.tags[key];
					}
				}
				else if(key && key==='utr'){
					obj2[key] = details.tags[key];
				}
				else{
					obj1[key] = details.tags[key];
				}
			})
			setTags1(obj1);
			setTags2(obj2);
		}
	},[details])

	useEffect(() => {
		fetchSettlements(id)
		fetchInvoiceCategoryForm();
		fetchInvoiceLineItemForm();
		fetchGrn(id);
		getAllIndependentCN();
	}, []);

	useEffect(() => {
		fetchInvoiceCategoryForm();
		fetchCreditNote(id);
	}, [details]);
 
	useEffect(() =>{
		fetchRoom()
		fetchCreditNote(id)
		fetchDebitNote(id)
		if(details.vendor){
			// Fetch vendor  address  to update vendor Address
			getVendorDetails()
		}
	},[])

	useEffect(()=>{
		if((tenant==="ASK" || tenant==="TESTASK" || tenant==="KARANDEVENV")){
			let flag=false;
			if(details && details.invoice && details.invoice.items && details.invoice.items.length){
				for(let i=0;i<details.invoice.items.length;i++){
					if(details.invoice.items[i] && details.invoice.items[i].tdsCode){
						flag=true;
						break;
					}
				}
			}
			if(flag){
				setAllowTdsAtLineItem(true);
				setAllowTdsAtHeader(false);
			}
			else if(details && details.taxInformation && details.taxInformation.tdsCode){
				setAllowTdsAtLineItem(false);
				setAllowTdsAtHeader(true);
			}
		}
	},[details])

	useEffect(() => {
		if (details && details.invoice && details.invoice.categoryId) {
			get(`vendor/config`, (e, r) => {
				if (r) {
					let find = r.items.find((e) => e.id === details.invoice.categoryId)
					setCategoryMapping(find.tags || {})
				}
			})
		}
	}, [details])
	

	useEffect(() => {
		if (revertBack) {
			get(`/vendor/invoicing/${revertBack}/fetch.approvers`, (e, r) => {
				if (r) {
					let items = [{ label: 'Uploader', value: 'uploader' }]
					const taxation =  typeof (details.content === 'string') ? JSON.parse(details.content): details.content
					if(taxation.isTaxation && (details.status !== 'TAXATION_APPROVAL')) {
						items.push({
							key: 'taxation',
							value: 'taxation'
						})
					}
					r.approvals.forEach((i, index) => {
						if (index <= r.approvals.length - 1)
							items.push({
								key: i.taskId,
								value: `${i.title} / ${i.employee ? i.employee.name : i.email} / ${i.employee ? i.employee.code : '-'}`
							})
					})
					setApprovalsList(items);
				}
			});
		}
	}, [revertBack])

	useEffect(()=>{
		get(`settings/exceptions/vendor`, (e,r)=>{
			if(r){
			  setInvoiceRoundOfAmountLimit(r.invoiceRoundOfAmountLimit);
			}
		})
	  },[])
	
	useEffect(() =>{
		if(tenant === "BSETEST") customFormLogic()
	},[prefill])
	
	const customFormLogic = () =>{
		if(categoryForm.length>0 && prefill){
			let deliveryDate = prefill['delivery_date']
			let days = prefill['credit_days']
			let issueRaised = prefill['issue_raised']
			let date = '';
			
			if(deliveryDate && days)  date = moment(deliveryDate,'DD-MM-YYYY').add(Number(days),'days').format('DD/MM/YYYY')								
			if(date) {
				const currentDate = moment().format("DD/MM/YYYY"); 
				const isFutureDate = moment(date, "DD/MM/YYYY").isAfter(moment(currentDate, "DD/MM/YYYY"));
				
				if(!isFutureDate) {
                    setDependentField(prev=>({
                        ...prev,
                        'credit_days_breach':'Yes',
						...(issueRaised && issueRaised === 'Yes') ? {'issue_raised':'Yes'}:{},
                    }))
                } else {
                    setDependentField(prev=>({
                        ...prev,
                        'credit_days_breach':'No',
                    }))
                }
			}
		}
	}

		
	useEffect(() => {
		let departmentName = prefill && prefill["department"];
		if (['PIRAMAL','prml'].includes(tenant) && InvoiceForm.length > 0 && departmentName) {
			let dep = InvoiceForm.find((e) => e.fieldId === "department");
			if (dep) {
				let id = details.address.id;
				if(id){
					get(`heirarchy/offices/${id}`, (e, r) => {
						if (r && r.departments && r.departments.length > 0) {
							let department = r.departments.find((e) => e.name === departmentName);
							if (department) {
								get(`heirarchy/department/${department.id}/details`, (e, r) => {
									if (r) {
										setCustomTags(r.tags);
									}
								});
							}
						}
					});
				}
			}
		}
	}, [InvoiceForm, prefill]);


	useEffect(()=>{
		if(details){
			if(!['BSETEST','KARANDEVENV','INDIAN'].includes(tenant)) return;
			let billDate = details.invoice? Moment(details.invoice.date,'DD-MM-YYYY').valueOf():false;
			let msme = details.vendor? details.vendor.msme: false;
			let rcVendor= details.vendor? details.vendor.rcVendor: false;;
			let createdAt = details.invoice? details.invoice.createdAt:false;
			const FYExceeded = hasExceeded180DaysFromFY(billDate);
			const RCMOverdue = RCMHasExcedded60Days(billDate,rcVendor);
			const MSME45Overdue = MSMEInvoice45DaysExceed(billDate,msme);
			const MSME15Overdue = MSMEInvoice15DaysExceed(createdAt,msme);
			setCustomFlags([{name:'FY Exceeded',flag:FYExceeded,color:'#5dd3c1'},{name:'RCM Overdue',flag:RCMOverdue,color:'#ff6f61'},{name:'MSME Overdue(Bill Date)',flag:MSME45Overdue,color:'rgb(240 170 8)'},{name:'MSME Overdue(Creation Date)',flag:MSME15Overdue,color:'rgb(255 111 247)'}])
		}
	},[details,tenant])

	const handleAddressChange=()=>{
		let billingGst=(selectedBillAddress && selectedBillAddress.gstin)?selectedBillAddress.gstin:"";
		let VendorGst=(selectedVendorAddress && selectedVendorAddress.des)?selectedVendorAddress.des:"";
        let cgst = 0,igst= 0,tax = 0;
		if(details && details.taxInformation && details.taxInformation.gst){
			tax=details.taxInformation.gst;
		}
		else if(details && details.invoice && details.invoice.items){
			details.invoice.items.forEach(item=>{
				tax += parseFloat((item && item.tax)?item.tax:0);
			})
		}

        if(VendorGst && VendorGst.length>2 && billingGst && billingGst && billingGst.length>2){
            if(VendorGst.slice(0,2)===billingGst.slice(0,2)){
                cgst = tax/2;
            }else{
                igst = tax;
            }
        }else{
            cgst = tax/2;
        }

		let key="";
		let value="";
		if(cgst){
			key="cgst"
			value=String(cgst)
		}
		else{
			key="igst"
			value=String(igst)
		}

		post(`/vendor/invoicing/${id}/change`, { 'key': key, 'value': value }, (e, r) => {
			if (r) {
				showToast({
					type: 'success',
					message: 'Field Updated'
				})
				onReload()
			} else if (e) {
				handleError(e);
				onReload()
			}
		});
    }

	const  getVendorDetails = () =>{
		let vendorId = details.vendor.id
		get(`vendor/contacts/${vendorId}/details`,(e,r)=>{
            if(r){
				let findDefault = r.addresses.filter((item)=>{return item && item.id}).find((e) => e.id === details.vendor.address.id) 
				let addresses = r.addresses.filter((item)=>{return item && item.id}).map(item => ({
					value: item.id,
					label: item.address,
					des: item.gstin
				}))
                setVendorAddress(addresses);
                setVendorAddressFilter(addresses);
				setVendorStatus(r.vendorStatus);
				if(findDefault){
					setSelectedVendorAddress({
						value: findDefault.id,
						label: findDefault.address,
						des: findDefault.gstin
					});
				}
				if(r && r.config && r.config.tdsMasterIds){
					setTdsSlabs(r.config.tdsMasterIds)
				}
				setVendorDetails(r)
            }else{
            }
        })
	}

	useEffect(()=>{
		setSelectedBillAddress({label:(details && details.address && details.address.title)?details.address.title:"",gstin:(details && details.address && details.address.gstin)?details.address.gstin:""})
		setSelectedShipAddress({label:(details && details.deliverTo && details.deliverTo.title)?details.deliverTo.title:"",gstin:(details && details.deliverTo && details.deliverTo.gstin)?details.deliverTo.gstin:"",shipTo:details.deliverTo.shipTo})
		setVendor({label:(details && details.vendor && details.vendor.name)?details.vendor.name:(details && details.vendor && details.vendor.tradeName)?details.vendor.tradeName:""})
	},[details])

	const fetchGrn = () => {
		get(`vendor/procurement/grn/allGrn?invoice_id=${id}&offset=0`,(e,r)=>{
            if(r){
                setGrn(r.responseItems);
            }else{
               // handleError(e)
            }
        })
	}



	const fetchCreditNote = (id) =>{
        get(`vendor/vendor/creditNote/getAll`,(e,r)=>{
            if(r){
                setCreditNotes(r.creditNotes);
            }else{
                handleError(e)
            }
        },{filter:[`${id}@t0.invoice_id`]})
    }

	const getAllIndependentCN = () => {
		let vendorId = details.vendor.id
		get(`vendor/vendor/creditNote/fetchAllIndependentCreditNotes?vendorId=${vendorId}`,(e,r)=>{
			if(r){
				let parsed =  (details.content && typeof details.content === 'string') ? JSON.parse(details.content): details.content
				setAllIndependentCN(r.creditNotes.filter(el => (el.status === "COMPLETED" && (['ANRCK','ANAROCK'].includes(tenant) || (el.amount <= (details.invoice.amount-parsed.creditNoteTotal))))));
			}
		})
	}

	const syncCreditNote = (creditNote) => {
		if(invoiceCreditNoteKnockoffAtSettlement && details.invoice.invoiceSettlementDetails && details.invoice.invoiceSettlementDetails.ledgerId){
			post(`vendor/vendor/creditNote/${details.invoice.id}/syncCreditNoteV2`,{
				'creditNoteId':Number(creditNote.id),
				'ledgerId':details.invoice.invoiceSettlementDetails.ledgerId
			},(e,r)=>{
				if(r){
					showToast({
						type:'success',
						message:'Credit Note Synced successfully'
					})
					getAllIndependentCN();
					props.onReload();
				}else{
					handleError(e);
				}
			})

		} else {
		 post(`vendor/vendor/creditNote/${details.invoice.id}/syncCreditNote`,{'creditNoteId':Number(creditNote.id)},(e,r)=>{
			if(r){
				showToast({
					type:'success',
					message:'Credit Note Synced successfully'
				})
				getAllIndependentCN();
				props.onReload();
			}else{
				handleError(e);
			}
		})
	}
	}

	const fetchDebitNote = (id) =>{
        get(`vendor/vendor/debitNotes/all`,(e,r)=>{
            if(r){
                setDebitNote(r.debitNotes);
            }else{
                handleError(e)
            }
        },{filter:[`${id}@t0.invoice_id`]})
    }


    const fetchRoom = () => {
        get(`workspace/seekClarification/getMyRooms`,(e,r)=>{
            if(r){
                setActiveRooms(r.rooms.filter((e => e.status === 'ACTIVE')));
            }
        },{
		type:'vendor-invoice',
		id})
    }
	

	const fetchInvoiceCategoryForm = () => {
		let singleLine = props.details.tags['inv_type']?props.details.tags['inv_type']==='single':false;
		if(singleLine) {
			let service = {};
			get('vendor/config/services',(e,r)=>{
				if(r) {
					r.items.forEach(el=>{
						service[el.name] = el.id;
					})
					get(`forms/vendor::${service[details.invoice.service]}`, (e, r) => {
						if (r) {
							setInvoiceForm(r.forms);
							setInvoiceFormOriginal(r.forms);
							let prefilldata = {};
							r.forms.forEach(el => {
								let val = details.tags[el.fieldId];
								prefilldata[el.fieldId] = val;
							})
							setPrefill(prefilldata);
						} else {
							handleError(e);
						}
					})
				}else {
					handleError(e);
				}
			})
		} else {
			get(`forms/vendor::category::${details.invoice.categoryId}`, (e, r) => {
				if (r) {
					setInvoiceForm(r.forms.map((item) => ({...item,editable:!approvalStatus(details.status)? false:item.editable})));
					setInvoiceFormOriginal(r.forms);
					let prefilldata = {};
					r.forms.forEach(el => {
						let val = details.tags[el.fieldId];
						prefilldata[el.fieldId] = val;
					})
					
					setPrefill(prefilldata);
				} else {
					handleError(e);
				}
			})
		}

		
	}
	const fetchInvoiceLineItemForm = () => {
		get(`forms/invoice::item::${details.invoice.categoryId}`, (e, r) => {
			if (r) {
				setLineItemForm(r.forms);
			} else {
				handleError(e);
			}
		})
	}

	useEffect(() => {
		setInvoices(details.invoice.items);
		CUSTOMFORM.current = CUSTOMFORM.current.slice(0, (details.invoice.items && details.invoice.items.length) || 0);
	}, [props.details])



	useEffect(()=>{
		if(status && approvalStatus(status)) {
			fetchRoom();
			if(tenant==="BSETEST" || tenant==="BSE") {
				getCategoryForm()
			}else {
				FORM.current && FORM.current.loadForm(`admin::invoice::category::${details.invoice.categoryId}`);
			}
			let apiUrl = details.status === 'TAXATION_APPROVAL' ? `taxation::invoice::item::${details.invoice.categoryId}` : `finance::invoice::item::${details.invoice.categoryId}`;
			getActiveCustomFormRefs().forEach((ref) => {
				ref.loadForm(apiUrl)
			})
		}
	}, [status,props.details])

	useEffect(() => {
		if (getTab === 1 && approvalStatus(status)) {
			fetchRoom();
			if(tenant==="BSETEST" || tenant==="BSE") {
				getCategoryForm()
			}else {
				FORM.current && FORM.current.loadForm(`admin::invoice::category::${details.invoice.categoryId}`);
				TAXATION_CATEGORY_FORM.current && TAXATION_CATEGORY_FORM.current.loadForm(`taxation::invoice::category::${details.invoice.categoryId}`);
			}
			let apiUrl = details.status === 'TAXATION_APPROVAL' ? `taxation::invoice::item::${details.invoice.categoryId}` : `finance::invoice::item::${details.invoice.categoryId}`;
			getActiveCustomFormRefs().forEach((ref) => {
				ref.loadForm(apiUrl)	
			})
		}
	}, [getTab])

    const getCategoryForm =()=>{
		get(`forms/admin::invoice::category::${details.invoice.categoryId}`,(e,r) =>{
			if(r){
				let forms = r.forms || []
				let prefilldata = {};
				r.forms.forEach(el => {
					let val = details.tags[el.fieldId];
					prefilldata[el.fieldId] = val;
				})
				// Get values from prefilldata for specific fields
				let date = prefilldata['delivery_date'] ? moment(prefilldata['delivery_date'], ['DD/MM/YYYY','YYYY-DD-MM','YYYY-MM-DD']).valueOf() : undefined;
				let days = prefilldata['credit_days']||0;
				let issueRaised = prefilldata['issue_raised']||'No';
				
				const deliveryDate = days && date ? moment(date).add(Number(days), "days").format("DD/MM/YYYY") : undefined;
				const currentDate = moment().format("DD/MM/YYYY");
				
				
				const isPast = moment(deliveryDate, "DD/MM/YYYY").isBefore(moment(currentDate, "DD/MM/YYYY"));
				
				
				// Handle raised_date field
				const tempForm = forms.map(el => {
					if (el.fieldId === "raised_date") {
						return {
							...el,
							prevDate: moment(date).format("YYYY-MM-DD"),
							placeholder: '',
							nextDate: moment(date).add(14, "days").format("YYYY-MM-DD")
						};
					}

					if (el.fieldId === "issue_resolution" && (tenant === "BSETEST")) {
						return {
							...el,
							prevDate: moment(date).format("YYYY-MM-DD"),
							placeholder: '',
							nextDate: moment().format("YYYY-MM-DD")
						};
					}
					return el;
				});

				if (FORM.current && FORM.current.updateForms) {
					FORM.current.updateForms(tempForm);
				}

				if (isPast) {
					setDependentField(prev => ({
						...prev,
						'credit_days_breach': 'Yes',
						...(getFieldId("raised_date",tempForm) && (issueRaised === 'Yes')) ? {'issue_raised':'Yes'}:{},
					}));
				} else {
					setDependentField(prev => ({
						...prev,
						'credit_days_breach': 'No'
					}));
				}
				setCategoryForm(tempForm);
				setPrefill(prefilldata);
				const accountingDate = forms.find(el => el.fieldId === 'accounting_date')
				setCategoryFormMap({[accountingDate.fieldId]: Moment(new Date()).format("DD/MM/YYYY")})
			}
		})
	}




	const getActiveCustomFormRefs = () => {
		const itemCount = (details.invoice.items && details.invoice.items.length) || 0;
		return CUSTOMFORM.current.slice(0, itemCount).filter(ref => ref);
	};

	const handleFormRef = (ref, index) => {
		if (ref) {
			CUSTOMFORM.current[index] = ref;
		}
	};

	const  checkTypeAsAdmin =(obj, status)  => {
		for (let i = 0; i < obj.values.length; i++) {
			if (
				obj.values[i].key === "Type" &&
				obj.values[i].value === "ADMIN" &&
				status !== "APPROVAL" &&
				status !== "POHOLD" &&
				status !== "COMPLETED" &&
				status !== "CANCELLED"
			) {
				return true;
			}
		}
		return false;
	}

	const VENDOR = (details && details.vendor) ||{};
	const msmeMicroVendor = ["BSETEST","BSE"].includes(tenant) && VENDOR['msmeType'] && ['micro','small'].includes(VENDOR['msmeType'].toLowerCase())

	const approveHandler = async () => {
		let data = {};
		let flag = true;
		let count = 0;
		let internalCount = 0;
		// to get custome line field values
		
		// Skip form processing when status is TAXATION_APPROVAL
		if (!skipApprovalForm()) {
			if (getActiveCustomFormRefs().some(ref => ref.isLoading())) {
				showToast({ type: 'error', message: 'Custom forms are loading, please wait...' });
				return;
			}
			getActiveCustomFormRefs().forEach((ref) => {
				flag = false;
				ref.getKeyValue(val => {
					if (Object.keys(val).length) {
						count++;
					}
					flag = true;

				});
			})
		}
		if (!flag) {
			showToast({
				type: 'error',
				message: "Please check line item custom first"
			})
			return
		}
		
		if(tenant === 'BSETEST' && msmeMicroVendor && details.vendor && (details.vendor.msme || details.vendor.msmeId) && FORM && FORM.current) {
			let validationFailed = false;
			FORM.current.getKeyValue(val => {
				if (val && categoryForm.length > 0) {
					const form = val
					
					let creditDaysItem = getFieldId("credit_days")
					let issueResolution =   getFieldId('issue_resolution')
					let deliveryDate = getFieldId('delivery_date')
					let issueRaised =   getFieldId('issue_raised') 
					
					if (creditDaysItem) {
						let creditDaysValue = form[creditDaysItem] && Number(form[creditDaysItem]); 
						if (!isNaN(creditDaysValue) && (creditDaysValue < 15 || creditDaysValue > 45)) {
							showToast({
								type: 'error',
								message: "Credit Days should be between 15 - 45"
							})
							validationFailed = true;
						}
					}
					
					if (issueResolution) {
						let issueResolutionDate;
						const dateValue = form[issueResolution];
						
						if (dateValue) {
							if (!isNaN(Number(dateValue))) {
								issueResolutionDate = moment(Number(dateValue));
							} else {
								const formats = ['DD-MM-YYYY','YYYY-MM-DD','YYYY-DD-MM'];
								issueResolutionDate = moment(dateValue, formats);
							}
						}

						let creditDays = Number(form[creditDaysItem]) || 0;
						let clonedDate = issueResolutionDate && issueResolutionDate.clone();
						let allowedDate = clonedDate && clonedDate.add(creditDays, 'days').startOf('day');
						let maxAllowedDate = moment().startOf('day'); 

						if (issueResolutionDate && issueResolutionDate.isValid() && maxAllowedDate.isBefore(allowedDate)) {
							showToast({
								type: 'error',
								message: `Allowed period expired (Issue Resolution + ${creditDays} days should be on or before today).`
							})
							validationFailed = true;
						}
					}

					if (creditDaysItem && deliveryDate && issueRaised) {
						let creditDaysValue = form[creditDaysItem] && Number(form[creditDaysItem]);
						let deliveryDateValue = form[deliveryDate] && moment(form[deliveryDate]);
						let issueRaisedValue = form[issueRaised];

						let deliveryFinalDate = deliveryDateValue && moment(deliveryDateValue).clone().add(creditDaysValue - 1, 'days').startOf('day');
						
						if (issueRaisedValue && issueRaisedValue === 'No' && deliveryFinalDate && deliveryFinalDate.isBefore(moment().startOf('day'))) {
							showToast({
								type: 'error',
								message: "Msme lapsed then issue raised in 15 days should be Yes"
							})
							validationFailed = true;
						}
					}
				}
			})
			
			if (validationFailed) {
				return;
			}
		}


		if(tenant === "BSETEST" && InvoiceFormOriginal.length>0 && prefill){
			let deliveryDate = moment(prefill['delivery_date']).format('DD/MM/YYYY')
			let days = prefill['credit_days']
			let date = '';

			if(deliveryDate && days)  date = moment(deliveryDate).add(Number(days),'days').format('DD/MM/YYYY')
			if(date) {
				const currentDate = moment().format("DD/MM/YYYY"); 
				const isFutureDate = moment(date, "DD/MM/YYYY").isAfter(moment(currentDate, "DD/MM/YYYY"));
				if(isFutureDate) {
					setSubmittingForm(true)
					return
				}
			} 
		} 

		if (count > 0) {
			details.invoice.items.forEach((i, index) => {
				let formValue = {};
				const formRef = CUSTOMFORM.current[index];
				if (!formRef) return;
				formRef.getKeyValue(val => {
					formValue = { ...val }
				})
				setBtnLoading(true);
				post(`vendor/invoicing/${details.invoice.id}/finance.item.form`, { "itemId": i.id, "itemForms": { ...formValue } }, (e, r1) => {
					if (r1) {
						internalCount++;
						if (internalCount === count) {
							setBtnLoading(false);
			
							FORM.current.getKeyValue(val => {
								data.forms = { ...data.forms, ...val };
								setBtnLoading(true);
								post(`/settlements/vendor/invoices/${details.invoice.id}/approve`, data, (e, r) => {
									if (r) {
										setBtnLoading(false);
										props.onReload();
										fetchSettlements(id)
										if(r.success === false){
											showToast({
												type: 'error',
												message: r.message
											})
										}else{
											showToast({
												type: 'success',
												message: 'Approved'
											})
										}
										
										
									} else {
										setBtnLoading(false);
										handleError(e)
									}
								})
							})

						}
					} else {
						setBtnLoading(false);
					}
				})
			})
		}




		if (flag) {
			if (count === 0) {
				if (!skipApprovalForm()) {
					FORM.current.getKeyValue(val => {
						data.forms = { ...data.forms, ...val };
						setBtnLoading(true);
						post(`/settlements/vendor/invoices/${details.invoice.id}/approve`, data, (e, r) => {
							if (r) {
								props.onReload();
								fetchSettlements(id)
								if(r.success === false){
									showToast({
										type: 'error',
										message: r.message
									})
								}else{
									showToast({
										type: 'success',
										message: 'Approved'
									})
								}
								setBtnLoading(false);
							} else {
								setBtnLoading(false);
								handleError(e);

							}
						})
					});
				} else {
					// For TAXATION_APPROVAL, approve without any form data
					setBtnLoading(true);
					post(`/settlements/vendor/invoices/${details.invoice.id}/approve`, data, (e, r) => {
						if (r) {
							props.onReload();
							fetchSettlements(id)
							if(r.success === false){
								showToast({
									type: 'error',
									message: r.message
								})
							}else{
								showToast({
									type: 'success',
									message: 'Approved'
								})
							}
							setBtnLoading(false);
						} else {
							setBtnLoading(false);
							handleError(e);
						}
					})
				}
			}

		} else {
			showToast({
				type: 'error',
				message: "Please check line item custom first"
			})
		}
	}

	const approveModal = async () => {
		let data = {};
		let flag = true;
		let count = 0;
		let internalCount = 0;
		// Skip form processing when status is TAXATION_APPROVAL
		if (approvalStatus(details.status)) {
			if (getActiveCustomFormRefs().some(ref => ref.isLoading())) {
				showToast({ type: 'error', message: 'Custom forms are loading, please wait...' });
				return;
			}
			getActiveCustomFormRefs().forEach((ref) => {
				flag = false;
				ref.getKeyValue(val => {
					if (Object.keys(val).length) {
						count++;
					}
					flag = true;

				});

			})
		}

		if (!flag) {
			showToast({
				type: 'error',
				message: "Please check line item custom first"
			})
			return
		}

		if (count > 0) {
			details.invoice.items.forEach((i, index) => {
				let formValue = {};
				const formRef = CUSTOMFORM.current[index];
				if (!formRef) return;
				formRef.getKeyValue(val => {
					formValue = { ...val }
				})
				post(`vendor/invoicing/${details.invoice.id}/finance.item.form`, { "itemId": i.id, "itemForms": { ...formValue } }, (e, r1) => {
					if (r1) {
						internalCount++;
						if (internalCount === count) {

							FORM.current.getKeyValue(val => {
								data.forms = { ...data.forms, ...val };
								setBtnLoading(true);
								post(`/settlements/vendor/invoices/${details.invoice.id}/approve`, data, (e, r) => {
									if (r) {
										setBtnLoading(false);
										props.onReload();
										fetchSettlements(id)
										setSubmittingForm(undefined)
										if(r.success === false){
											showToast({
												type: 'error',
												message: r.message
											})
										}else{
											showToast({
												type: 'success',
												message: 'Approved'
											})
										}
									} else {
										setBtnLoading(false);
										handleError(e)
									}
								})
							})

						}
					} else {
						setBtnLoading(false);
					}
				})
			})
		}




		if (flag) {
			if (count === 0) {
				// Skip form processing when status is TAXATION_APPROVAL
				if (!approvalStatus(details.status)) {
					FORM.current.getKeyValue(val => {
						data.forms = { ...data.forms, ...val };
						setBtnLoading(true);
						post(`/settlements/vendor/invoices/${details.invoice.id}/approve`, data, (e, r) => {
							if (r) {
								props.onReload();
								fetchSettlements(id)
								setSubmittingForm(undefined)
								if(r.success === false){
									showToast({
										type: 'error',
										message: r.message
									})
								}else{
									showToast({
										type: 'success',
										message: 'Approved'
									})
								}
								setBtnLoading(false);
							} else {
								setBtnLoading(false);
								handleError(e);

							}
						})
					});
				} else {
					// For TAXATION_APPROVAL, approve without any form data
					setBtnLoading(true);
					post(`/settlements/vendor/invoices/${details.invoice.id}/approve`, data, (e, r) => {
						if (r) {
							props.onReload();
							fetchSettlements(id)
							setSubmittingForm(undefined)
							if(r.success === false){
								showToast({
									type: 'error',
									message: r.message
								})
							}else{
								showToast({
									type: 'success',
									message: 'Approved'
								})
							}
							setBtnLoading(false);
						} else {
							setBtnLoading(false);
							handleError(e);
						}
					})
				}
			}

		} else {
			showToast({
				type: 'error',
				message: "Please check line item custom first"
			})
		}
	}

	const fetchSettlements = (ID) => {
		if(utilities) return;
		get(`settlements/settlements/invoice/${ID}/detailsV2`, (e, r) => {
			if (r) {
				setSettlements(r);
				setLoading(false);
			} else if (e) {
				if (e.data.message === 'Settlement not found') {
					setSettlements({ settlements: [], settled: false })
				} else {
					handleError(e)
				}
				setLoading(false);
			}
		})
	}

	const onRcmChange = (val) =>{
		setRcm(val)
		post(`/vendor/invoicing/${id}/details.change`, {
			 "key":"rcm",
			  value:`${val}`
			 }, (e, r) => {
			if (r) {
				setVendor('');
				onReload()
				showToast({
					type: 'success',
					message: 'Invoice Updated'
				})
			} else if (e) {
				handleError(e);
			}
		});
	}

	const updateInvoice = (field, value) => {

		let key = '';
		switch (field) {
			case 'vendorAddress':
				post(`/vendor/invoicing/${id}/change`, { key: 'vendorAddress',value: String(selectedVendorAddress.value) }, (e, r) => {
					if (r) {
						setToggleAddress(undefined);
						showToast({
							type: 'success',
							message: 'Vendor address Updated'
						})
						handleAddressChange()
					} else if (e) {
						handleError(e);
					}
				});
				return;
			case 'vendor':
				post(`/vendor/invoicing/${id}/vendor.change`, { vendor: getVendor.value }, (e, r) => {
					if (r) {
						setVendor('');
						onReload()
						showToast({
							type: 'success',
							message: 'Vendor Updated'
						})
					} else if (e) {
						handleError(e);
					}
				});
				return;
			case 'id':
				key = 'invoice';
				break;
			case 'bill':
				post(`/vendor/invoicing/${id}/change`, {
					key: 'billing',
					value: String(selectedBillAddress.value)
				}, (e, r) => {
					if (r) {
						setToggleBillAddress(undefined);
						showToast({
							type: 'success',
							message: 'Billing Address Updated'
						})
						handleAddressChange()
					} else if (e) {
						handleError(e);
					}
				});
				return;
			case 'ship':
				post(`/vendor/invoicing/${id}/change`, {
					key: 'address',
					value: String(selectedShipAddress.value)
				}, (e, r) => {
					if (r) {
						onReload()
						setToggleShipAddress(undefined);
						showToast({
							type: 'success',
							message: 'Shipping Address Updated'
						})
					} else if (e) {
						handleError(e);
					}
				});
				return;

			case 'date':
				post(`/vendor/invoicing/${id}/change`, {
					key: "date",
					value: Moment(value, "YYYY-MM-DD").format('DD-MM-YYYY')
				}, (e, r) => {
					if (r) {
						onReload();
						showToast({
							type: 'success',
							message: 'Invoice Date Updated'
						})
					} else if (e) {
						handleError(e);
					}
				});
				return;
			case 'due':
				post(`/vendor/invoicing/${id}/change`, {
					key: "due",
					value: Moment(value, "YYYY-MM-DD").format('DD-MM-YYYY')
				}, (e, r) => {
					if (r) {
						onReload();
						showToast({
							type: 'success',
							message: 'Invoice Due Date Updated'
						})
					} else if (e) {
						handleError(e);
					}
				});
				return;

			case 'base':
				key = 'base';
				break;
			case 'tds':
				key = 'tds.fixed';
				break;
			case 'sgst':
				key = 'sgst';
				break;
			case 'igst':
				key = 'igst';
				break;
			case 'cgst':
				key = 'cgst';
				break;
			case 'roundOff':
				key = 'roundOff';
				break;
			case 'tcs':
				key = 'tcs'
				break;
			case 'discount':
				key = 'discount';
				break;
			default:
				return;
		}

		post(`/vendor/invoicing/${id}/change`, { 'key': key, 'value': value }, (e, r) => {
			if (r) {
				onReload()
				showToast({
					type: 'success',
					message: 'Field Updated'
				})
			} else if (e) {
				handleError(e);
			}
		});
	}

	const updateInsight = (key, val, multi=false) => {
		const creditDaysCheck = (tenant === "BSETEST") && ['credit_days'].includes(key)
		if(creditDaysCheck && (Number(val) < 15 || Number(val) > 45)){
			showToast({
				type: 'error',
                message: "Credit Days should be between 15 - 45"
			})
			prefill[key] = '';
			return
		}
		return new Promise((resolve,reject)=>{
			post(`/vendor/invoicing/${id}/change`, { 'key': key, 'value': val }, (e, r) => {
				if (r) {
					if(!multi){
						onReload()
					}
					// form only reload for specific case 
					if((tenant === "BSETEST") && ['credit_days','delivery_date'].includes(key)){
						customFormLogic()
					}

					showToast({
						type: 'success',
						message: 'Insight Updated'
					})
					resolve(true);
				} else if (e) {
					handleError(e);
					resolve(false);
				}
			});
		})
	}

	const updateInsightLineItem = (id1, key, val) => {
		post(`/vendor/invoicing/${id}/details.change`, { 'key': key, 'value': val, itemId: id1 }, (e, r) => {
			if (r) {
				onReload()
				showToast({
					type: 'success',
					message: 'Insight Updated'
				})
			} else if (e) {
				handleError(e);
			}
		});
	}

	const updateLineItemCustomForm = (key,value,itemId) => {
		let itemIds = isArray(itemId) ? itemId : [itemId];
		const updateOne = (item) => new Promise((resolve) => {
			post(`/vendor/invoicing/${id}/change`, { key,value,itemId:item}, (e, r) => {
				if (r) {
					resolve(true);
				} else {
					handleError(e);
					resolve(false);
				}
			});
		})
		return (async () => {
			let updated = 0;
			for(let i=0;i<itemIds.length;i++){
				if(await updateOne(itemIds[i])) updated++;
			}
			if (updated) {
				onReload()
				showToast({
					type: 'success',
					message: itemIds.length > 1 ? `Value Updated Sucessfully for ${updated} line items` : 'Value Updated Sucessfully'
				})
			}
			return updated === itemIds.length;
		})();
	}


	const renderInvoiceCustomForm = (item, index) => {
		let type = item.type.toLowerCase();
		let prefillData = prefill[item.fieldId];
		if (type === 'date' && prefillData) {
			const parsedDate = moment(prefillData, 'YYYY-MM-DD', true);
			if (!parsedDate.isValid()) {
				prefillData = Moment(prefillData, 'DD-MM-YYYY').format('YYYY-MM-DD');
			}
		}
		
		if ((type === 'email' || type === 'number' || type === 'text' || type === 'date')) {
			return (
				<FloatInputButton
					disabled={disableUpdate}
					maxLength={item.max}
					min={item.min}
					key={item.id}
					title={item.name}
					placeholder={prefillData || ""}
					type={item.type.toLowerCase()}
					onSubmit={(val) => {
						prefill[item.fieldId] = val;
						updateInsight(item.fieldId, val);
						onReload()
					}}
				/>)
		} else if (type === "select") {
			return (
				<div key={index} className="full-width">
					<FloatSelect
						disabled={disableUpdate}
						value={prefillData ? { key: prefillData, value: prefillData } : {}}
						firstValue={true}
						key={index}
						title={item.name}
						onChange={(val) => {
							prefill[item.fieldId] = val;
							updateInsight(item.fieldId, val);
						}}
						items={item.values}
					/>
				</div>
			)
		}
		else if (type === "multiselect") {
			return (
				<>
					<label className="floating-top-label" >{item.name}:</label>
					<MultiSelect disabled={disableUpdate}
						options={item.values.map(j => ({ value: j.value, label: j.key }))}
						value={prefillData ? prefillData.split(';').map(val => { return { value: val, label: val } }) : []}
						onChange={(selected) => {
							selected = selected.filter(el => el.value !== "");
							prefill[item.fieldId] = selected.length ? selected.map(el => el.value).join(';') : '';
							updateInsight(item.fieldId, selected.length ? selected.map(el => el.value).join(';') : '');
						}}
						labelledBy={item.name}
					/>
				</>
			)
		}
		else if (type === 'file') {
			return (
				<>
					{!prefillData ? <FloatFile
						disabled={disableUpdate}
						key={index}
						title={item.name}
						required={item.required}
						placeholder={`Select File`}
					/> :
						<><label className="floating-top-label" >
							{
								item.name
							}:
						</label>
							<Attachments
								fileName={"Attachment"}
								multiple={true}
								editable={false}
								attachments={[prefillData]}
								onDelete={(val) => {
									if(disableUpdate) return;
									prefill[item.fieldId] = "";
									updateInsight(item.fieldId, "");
								}}
							/>
						</>
					}
				</>
			)
		}
		else if (type === 'master') {
			return (
				<FindMaster
					disabled={disableUpdate}
					key={index}
					title={item.name}
					required={item.required}
					placeholder={`Search the ${item.placeholder}`}
					fieldId={item.fieldId ? item.fieldId : item.name}
					details={item}
					defaultValue={prefillData ? prefillData : ""}
					onUpdate={(i, next) => {
						let tempMaster = { ...master };
						let key = next
						tempMaster[key] = i[key];
						setMaster(tempMaster);
						prefill[item.fieldId] = i[key];
						updateInsight(item.fieldId, i[key]);
					}}
					master={master}
				/>
			)
		}
	}

	// const upload = (file,i) => {
	// 	post(`vendor/invoicing/${id}/attachment`, {file:file,name:`${i}` }, (e, r) => {
	// 	  if (r) {
	// 		onReload();
	// 		showToast({
	// 		  type: "success",
	// 		  message: "File Uploaded successfully",
	// 		});
	// 	  }
	// 	});
	//   };


	const renderTags = (item, index) => {
		if (['APPROVAL','TAXATION_APPROVAL'].includes(details.status)) {
		if (item[0] !== 'start_date' && item[0] !== 'end_date') {
			let place = InvoiceForm.findIndex(f => (f.fieldId === item[0]));
			if (place > -1) return;
		}
		}
		const isFile = fileExtensions.some(extension => item[1].includes(extension)) || isHttpLink(item[1]);
		if (isFile) {
			return (
				<div key={`Tag-${index}`} style={{ display: 'flex', alignItems: 'center', marginTop: 5 }}>
					<FloatFile2
						fileUrl={item[1]}
						key={item[0]}
						title={item[0]}
						// onUpload={(val) => upload(val,j)}
						placeholder={`Select File`}
					/>
				</div>
			)
		}
		return (
			<div key={`Tag-${index}`} style={{ display: 'flex', alignItems: 'center' }}>
				<FloatInputButton disabled={disableUpdate} style={{ width: '100%' }} onSubmit={(val) => { updateInsight(item[0], val) }} title={item[0]} placeholder={item[1]} />
			</div>
		)
	}


	const mapLineItemTag = (item, index) => {
		return (
			<div key={index} style={{ border: '1px solid var(--border-color)', padding: 12, borderRadius: 12, marginTop: 20 }}>
				<FloatInputButton disabled={true} style={{ width: '100%' }} title={"Item Name Custom Form"} placeholder={item.name} />

				{

					item.data.map((form, j) => {
						let tempForm = LineItemForm.find(el => el.fieldId === form.id);
						if (tempForm) {
							let type = tempForm.type.toLowerCase();
							let prefillData = form.value;
							if (type === 'date' && prefillData) {
								const parsedDate = moment(prefillData, 'YYYY-MM-DD', true);
								if (!parsedDate.isValid()) {
									prefillData = Moment(prefillData, 'DD-MM-YYYY').format('YYYY-MM-DD');

								}
							}
							if ((type === 'email' || type === 'number' || type === 'text' || type === 'date')) {
								return (
									<FloatInputButton
										disabled={disableUpdate}
										maxLength={tempForm.max}
										min={tempForm.min}
										key={tempForm.id}
										title={tempForm.name}
										placeholder={prefillData || ""}
										type={tempForm.type.toLowerCase()}
										onSubmit={(val) => {
											updateInsightLineItem(item.id, tempForm.fieldId, val);
											onReload()
										}}
									/>)
							} else if (type === "select") {
								return (
									<div key={index} className="full-width">
										<FloatSelect
											disabled={disableUpdate}
											value={prefillData ? { key: prefillData, value: prefillData } : {}}
											firstValue={true}
											key={index}
											title={tempForm.name}
											onChange={(val) => {
												updateInsightLineItem(item.id, tempForm.fieldId, val);
											}}
											items={tempForm.values}
										/>
									</div>
								)
							}
							else if (type === "multiselect") {
								return (
									<>
										<label className="floating-top-label" >{tempForm.name}:</label>
										<MultiSelect disabled={disableUpdate}
											options={tempForm.values.map(j => ({ value: j.value, label: j.key }))}
											value={prefillData ? prefillData.split(';').map(val => { return { value: val, label: val } }) : []}
											onChange={(selected) => {
												selected = selected.filter(el => el.value !== "");
												updateInsightLineItem(item.id, tempForm.fieldId, selected.length ? selected.map(el => el.value).join(';') : '');
											}}
											labelledBy={tempForm.name}
										/>
									</>
								)
							}
							else if (type === 'file') {
								return (
									<>
										{!prefillData ? <FloatFile
											disabled={disableUpdate}
											key={index}
											title={tempForm.name}
											required={tempForm.required}
											placeholder={`Select File`}
										/> :
											<><label className="floating-top-label" >
												{
													tempForm.name
												}:
											</label>
												<Attachments
													fileName={"Attachment"}
													multiple={true}
													editable={false}
													attachments={[prefillData]}
													onDelete={(val) => {
														updateInsightLineItem(item.id, tempForm.fieldId, "");
													}}
												/>
											</>
										}
									</>
								)
							}
							else if (type === 'master') {
								return (
									<FindMaster
										disabled={disableUpdate}
										key={index}
										title={tempForm.name}
										required={tempForm.required}
										placeholder={`Search the ${tempForm.placeholder}`}
										fieldId={tempForm.fieldId ? tempForm.fieldId : tempForm.name}
										details={tempForm}
										defaultValue={prefillData ? prefillData : ""}
										onUpdate={(i, next) => {
											let tempMaster = { ...masterLI };
											let key = next
											tempMaster[key] = i[key];
											setMasterLI(tempMaster);
											updateInsightLineItem(item.id, tempForm.fieldId, i[key]);
										}}
										master={masterLI}
									/>
								)
							} else {
								return <></>
							}
						} else {
							return (<div key={`Tag-${j}`} style={{ display: 'flex', alignItems: 'center' }}>
								<FloatInputButton disabled={disableUpdate} style={{ width: '100%' }} onSubmit={(val) => { updateInsightLineItem(item.id, form.id, val) }} title={form.key} placeholder={form.value} />
							</div>)
						}
					})
				}
			</div>
		)
	}

	const mapView = (item, index) => {
		return (
			<div key={index} style={{ border: '1px solid var(--border-color)', padding: 12, borderRadius: 12, marginTop: 20 }}>
				<p style={{ fontSize: 12 }}>{item.title}</p>
				<p style={{ fontSize: 10, marginTop: 2 }}>{item.description}</p>
				<p style={{ fontSize: 10, marginTop: 2 }}>Created At : {Moment(item.date).format('DD-MM-YYYY')}</p>
				{item.values.map((i, j) => {
					if(i && i.key==="Bill Number" && (i.value && i.value==="NA")){
						i.value=(details && details.invoice && details.invoice.invoiceId)?details.invoice.invoiceId:(details && details.invoice && details.invoice.billNumber)?details.invoice.billNumber:"NA"
					}
					const isFile = fileExtensions.some(extension =>  i.value && i.value.includes(extension));
					if (isFile) {
						return (
							<Attachments
								fileName={"Attachment"}
								multiple={true}
								editable={false}
								attachments={[i.value]}
							/>
						)
					}
					return (
						<div key={`Tag-${j}`} style={{ display: 'flex', alignItems: 'center' }}>
							<FloatInputButton disabled={true} style={{ width: '100%' }} title={i.key} placeholder={i.value} />
						</div>
					)
				})}
			</div>
		)
	}

	let tabs = [
		{
			name: 'Format', active: getTab === 1, onClick: () => {
				setTab(1)
			}
		},
		...gst2bRecon ?
			[
				{
					name: 'Recon', active: getTab === 8, onClick: () => {
						setTab(8)
					}
				}
			] : [],

		{
			name: 'Insight', active: getTab === 2, onClick: () => {
				setTab(2)
			}
		},
		{
			name: 'Timeline', active: getTab === 3, onClick: () => {
				setTab(3)
			}
		},
		...(details.invoice.logs && details.invoice.logs.length>0) ?
			[
				{
					name: 'Logs', active: getTab === 12, onClick: () => {
						setTab(12)
					}
				}
			] : [],
		...!utilities?[
			{
				name: 'Settlements', active: getTab === 4, onClick: () => {
					setTab(4)
				}
			},
			...partialSettlementRequestFlow ?
			[
				{
					name: 'Partial Settlement Requests', active: getTab === 16, onClick: () => {
						setTab(16)
					}
				}
			] : [],
			{
			name: 'Ticket', active: getTab === 6, onClick: () => {
				setTab(6)
			}
		}]:[],
		...creditNote&&!utilities ? [
		{
			name: 'CN. Note', active: getTab === 10, onClick: () => {
				setTab(10)
			}
		}]:[],
		...debitNotePlugin ? [
			{
				name: 'DB. Note', active: getTab === 11, onClick: () => {
					setTab(11)
				}
			}]:[],
			{
				name: 'Ocr Details', active: getTab === 13, onClick: () => {
					setTab(13)
				}
			},
			{
				name: 'IMS Details', active: getTab === 15, onClick: () => {
					setTab(15)
				}
			},
	]

	let { integrationData, irnData ,ocrMismatches,ocrData,ocrV2Data,grnNos,startDate,endDate} = typeof details.content === 'string' ? JSON.parse(details.content) : details.content   //JSON.parse(details.content);
	
	const {costAllocationDone} = details && details.invoice;
	if (integrationData && Object.keys(integrationData).length) {
		tabs.push({
			name: 'Integration', active: getTab === 7, onClick: () => {
				setTab(7)
			}
		})
	}

	if (po || (props.details && props.details.po && isArray(props.details.po) && props.details.po.length>0)) {
		tabs.push({
			name: 'Po', active: getTab === 5,
			onClick: () => {
				setTab(5)
			}
		})
		if(enableGin){
			tabs.push({
				name: 'GIN', 
				active: getTab === 14,
				 onClick: () => {
					setTab(14)
				}
			})
		}
	}

	if (details.tags && details.tags['contract.id']) {
        tabs.splice(2, 0, {
			name: 'Contract', active: getTab === 9,
			onClick: () => {
				setTab(9)
			}
		});
    }

	let parsed =  (details.content && typeof details.content === 'string') ? JSON.parse(details.content): details.content
	

	const onRepost = () =>{
		post(`workspace/integration/triggerUpdateInvoice`, {
			invoiceId: details.invoice.counterId,
			"data":{
				"sap_retrigger_remarks:":`Manually Re-Triggered by user ar ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
			},
			"postingTriggered":false,
			"postingFailed":false,
			"postingSynced":false
		}, (e,r)=>{
			if(e){
				handleError(e)
			}else{
				onReload()
				setRepost(undefined)
				showToast({
					type: 'success',
					message: 'Invoice Re-post Successfully'
				})
			}
		})
	}

	
	let SGstEnable = true;
	const  vendorGstIn = details && details.vendor && details.vendor.gstin;
	const billGstIn = details && details.address && details.address.gstin;
	let category = details && details.category;
	if (vendorGstIn && vendorGstIn.length > 2 && billGstIn && billGstIn.length > 2) {
		if (vendorGstIn.slice(0, 2) === billGstIn.slice(0, 2)) {
			SGstEnable= true
		} else {
			SGstEnable = false
		}
	} 

	const renderFiles = (file, index) => {
		if(file.endsWith('.pdf')){
			return <iframe onClick={()=>window.open(file,'_blank')} key={index} src={file} title='Preview' className='pointer mt1' style={{border: 'none', width:'100%', height: '100vh'}}/>
		}else{
			return <img onClick={()=>window.open(file,'_blank')} src={file} alt='Attachment' className='w-100 mt1 pointer'/>
		}
	}

	// custom dependent value passed for filter
	const adjustedInvoice = invoices && invoices.length>0 && invoices.every(item => item.allowBlockedItemSubmission);
	
	let dependentmaster = {};
	let dependentmasterValue = {};
	let dependentmasterValueLineItem ={}
	
	if (loading) {
		return <PageLoader />
	}

	if(tenant==='FMLT' || tenant==='FMLOG') {
		if(details.tags && details.tags["customer_id"]) {
			dependentmaster = {
				"customer_name":details.tags["customer_id"]
			}
		}
		
		
	}

	if(tenant === 'BAJELEC1' || tenant === 'BAJEL') {
		if(details.tags && details.tags["mismatch"]) {
			dependentmasterValue = {
				"mismatch":details.tags["mismatch"]
				}
			}
	}
	if((tenant === "BSETEST" || tenant === "BSE") && msmeMicroVendor &&  details.vendor && (details.vendor.msme || details.vendor.msmeId)) {
		dependentmasterValue['MSME_VENDOR'] = 'Yes'
	}

	if(props && props.details && props.details.tags && props.details.tags.order){
		dependentmasterValue={...dependentmasterValue,"po_id":"yes"}
	}
	else{
		dependentmasterValue={...dependentmasterValue,"po_id":"no"}
	}

	if(details.invoice.items && details.invoice.items.length>0 && ['APPROVAL','TAXATION_APPROVAL'].includes(details.status)){
		details.invoice.items.forEach(item=>{
			dependentmasterValueLineItem={...dependentmasterValueLineItem,[item.id]:{...dependentmasterValueLineItem[item.id],...item.attrs}}
			if(props && props.details && props.details.tags && props.details.tags.order){
				dependentmasterValueLineItem={...dependentmasterValueLineItem,[item.id]:{...dependentmasterValueLineItem[item.id],"po_id":"yes"}}
			}
			else{
				dependentmasterValueLineItem={...dependentmasterValueLineItem,[item.id]:{...dependentmasterValueLineItem[item.id],"po_id":"no"}}
			}
			if(props && props.details && props.details.tags && props.details.tags['po.pr_iom'] &&  (props.details.tags['po.pr_iom'] === 'IOM')){
				dependentmasterValueLineItem={...dependentmasterValueLineItem,[item.id]:{...dependentmasterValueLineItem[item.id],"po_id":"no"}}
			}
		})
	}
	
	if(adjustedInvoice){
		dependentmasterValue = {...dependentmasterValue,'allowBlockedItemSubmission':'yes'}
	}

	const onAddUtr = (val) => {
		const ledgerId = Settlements && Settlements.ledgerId
		if(val)
	    	post(`settlements/settlements/settlements/${ledgerId}/addUtr`,{utr:val},(e,r) =>{
			if(r){
				onReload();
				fetchSettlements(id);
				showToast({
					type:'success',
					message:"Utr Updated successfully"
				})
			} else {
				handleError(e)
			}
		})
	}
	
    const ennableOnTaxation = ['ANRCK','ANAROCK'].includes(tenant) ? (details.status === 'TAXATION_APPROVAL'): true;
	// Disable RCM
	const disableRcm = categoryMapping['disable_rcm'] && categoryMapping['disable_rcm'] === 'yes';

	const calculateTotalPayable = () => {
		let totalPayable = Number(details.taxInformation.paidAmount) || 0;
		const creditNoteTotal =  parsed && parsed.creditNoteTotal
		const debitNoteTotal =  parsed && parsed.debitNoteTotal
		const creditNoteTds = (parsed.creditNoteTds||0)
		if ((parsed && parsed.creditNote)||  (parsed && parsed.debitNote)) {
			let credit = Number(creditNoteTotal) || 0;
			let debit = Number(debitNoteTotal) || 0;
			totalPayable = totalPayable - credit + debit;
		}
	
		if (creditNoteTds) {
			totalPayable += creditNoteTds;
		}

		const totalAdditionalCharge = details.taxInformation && details.taxInformation.totalAdditionalCharge ? details.taxInformation.totalAdditionalCharge : 0
		const baseAdditionalCharge = details.taxInformation && details.taxInformation.baseAdditionalCharge ? details.taxInformation.baseAdditionalCharge : 0
		const grossAdditionalCharge = details.taxInformation && details.taxInformation.grossAdditionalCharge ? details.taxInformation.grossAdditionalCharge : 0
		const additionalChargesTds = details.taxInformation && details.taxInformation.additionalChargesTds ? details.taxInformation.additionalChargesTds : 0

		let totalChargesCombine = totalAdditionalCharge + baseAdditionalCharge + grossAdditionalCharge - additionalChargesTds;
	
		let totalTax = Number(details.taxInformation.gst) || 0;
	
		if ((details.invoice.rcInvoice || isRcm) && (Settlements && Settlements)) {
			totalPayable = (totalPayable - totalTax + totalChargesCombine).toFixed(2);
		} else {
			totalPayable = (totalPayable - totalTax + totalChargesCombine).toFixed(2);
		}

		return Number(totalPayable);
	};

	const MapInvoiceForm = useCallback(() => {
		return (
			<InvoiceCategoryForm
				forms={InvoiceForm}
				details={details}
				prefill={prefill}
				dependentField={dependentField}
				updateInsight={updateInsight}
			/>
		)
	}, [prefill,InvoiceForm,dependentField])

    const getFieldId = (fieldName,forms=[]) => {
		const items = (forms && forms.length>0) ? forms : categoryForm
    	const field = items.find(f => f.fieldId === fieldName);
	    return field ? field.id : null;
   }

	const onChangeCatrgotyForm = async (item, value) => {
	  if(FORM && FORM.current){
		FORM.current.getFilledKeyValue((data) => {
			let element = undefined;
			categoryForm.forEach((el) => {
				Object.keys(data).some((e) => {
					if (Number(e) === el.id && (Number(e) !== value.id)) {
						if (
							(item.fieldId === 'delivery_date' && el.fieldId === 'credit_days') ||
							(item.fieldId === 'credit_days' && el.fieldId === 'delivery_date')
						) {
							element = {
								id: el.id,
								value: data[e] || '',
								item: el.fieldId,
							};

							return true;
						}
					}
					return false;
				});
			});
			
			if (element) {
				let date = item.fieldId === 'delivery_date' ? value : element && element.value ? moment(element.value, 'YYYY-MM-DD').valueOf() : undefined;
				let days = item.fieldId === 'delivery_date' ? (element && element.value) : value;

				const deliveryDate = days && date ? moment(date).add(Number(days), "days").format("DD/MM/YYYY") : undefined;
				const currentDate = moment().format("DD/MM/YYYY");
				
				const isPast = moment(deliveryDate, "DD/MM/YYYY").isBefore(moment(currentDate, "DD/MM/YYYY"));
				const tempForm = categoryForm.map(el =>
					el.fieldId === "raised_date"
						? {
							...el,
							prevDate: moment(date).format("YYYY-MM-DD"),
							placeholder: '',
							nextDate: moment(date).add(14, "days").format("YYYY-MM-DD")
						}
						: el
				);

				let raisedDateId = getFieldId("raised_date");
				let issueResolutionId = getFieldId("issue_resolution");
				let effectiveDateId = getFieldId("effective_date");
				setCategoryForm(tempForm);
				if (FORM && FORM.current) {
					FORM.current.updateForms(tempForm)
					if (issueResolutionId) {
						FORM.current.setValues({
							issue_resolution: ''
						});
					}
					if (raisedDateId) {
						FORM.current.setValues({
							raised_date: ''
						});
					}

					if (effectiveDateId) {
						FORM.current.setValues({
							effective_date: moment(date).format("DD-MM-YYYY")
						});
					}
				}

				
				if (isPast) {
					setDependentField(prev => ({
						...prev,
						'credit_days_breach': 'Yes',
					}));
				} else {
					setDependentField(prev => ({
						...prev,
						'credit_days_breach': 'No',
						'issue_raised':'No'
					}));
				}
			}
		});

		if (item.fieldId === "raised_date" && (tenant === "BSETEST")) {
			if (FORM && FORM.current) {
				const tempForm = categoryForm.map(el =>
					el.fieldId === "issue_resolution"
						? {
							...el,
							prevDate: moment(value).format("YYYY-MM-DD"),
							placeholder: '',
							nextDate: moment().format("YYYY-MM-DD")
						}
						: el
				);
				setCategoryForm(tempForm);
				FORM.current.updateForms(tempForm);
				let raisedDateId = getFieldId("issue_resolution");
				let effectiveDateId = getFieldId("effective_date");

				if (raisedDateId) {
					FORM.current.setValues({
						issue_resolution: ''
					});
				}
				if (effectiveDateId) {
					FORM.current.setValues({
						effective_date: ''
					});
				}
			}
		}

		if (item.fieldId === "issue_resolution" && (tenant === "BSETEST")) {
			let effectiveDateId = getFieldId("effective_date");
	
			if (FORM && FORM.current) {
			  if (effectiveDateId) {
				FORM.current.setValues({
					effective_date: moment(value).format("DD-MM-YYYY")
				});
		  	}
			}
		}
	}
	}

	
	const LineItemForms = useCallback(() => {
		return (
			<>
				{details.invoice.items.map((line, index) => { 
					return (
						<Form2
							key={line.id}
							setLineItemForms={setLineItemForms}
							dependentKeyValue={dependentmasterValueLineItem && dependentmasterValueLineItem[line.id] ? dependentmasterValueLineItem[line.id] : {}}
							initialValues={line.attrs}
							handler={ref => handleFormRef(ref, index)}
							label={`${index + 1}). ${line.name ? line.name : ""}-${line.service ? line.service : ""} ${details.status === 'TAXATION_APPROVAL' ? 'Taxation' : 'Finance'} Line Item Field`}
							updateForm={(key, value) => updateLineItemCustomForm(key, value, line.id)}
							tenant={tenant}
							categoryId={(props.details && props.details.invoice && props.details.invoice.categoryId) ? props.details.invoice.categoryId : null}
						/>
					)
				}
				)}

			</>
		)
	}, [details])
	const approveDetails = (item) => {
		return (
			<div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
				<div style={{ flex: 1 }}>
					<div style={{ fontSize: "14px", color: "#667085" }}>Invoice Amount</div>
					<div style={{ fontSize: "16px", fontWeight: "500" }}>{item.invoice.currency} {numberWithCommas(item.invoice.amount)}</div>
				</div>
				<div style={{ flex: 1 }}>
					<div style={{ fontSize: "14px", color: "#667085" }}>Discounting Rate</div>
					<div style={{ fontSize: "16px", fontWeight: "500" }}>{item.discountingData.rate}%{' '}<span style={{ fontSize: "14px", color: "#6c757d" }}>per month</span></div>
				</div>
				<div style={{ flex: 1 }}>
					<div style={{ fontSize: "14px", color: "#667085" }}>Final Amount Payable</div>
					<div style={{ fontSize: "16px", fontWeight: "500" }}>{item.invoice.currency} {numberWithCommas(item.invoice.amount * ((100 - item.discountingData.rate) / 100))}</div>
				</div>
			</div>
		)
	}

	const handleApprove = (id) => {
		post(`/vendor/invoiceDiscounting/approve`, { invoiceId: id }, (e, r) => {
			if (r) {
				showToast({
					type: 'success',
					message: r.message ? r.message : "Invoice Discounting Approved"
				})
			} else {
				handleError(e)
			}
			setApproveDiscountingModal(null);
		})

	}

	const handleDecline = (id) => {
		const remark = REMARK2.current.value();
		if(!remark){
			showToast({
				type: 'error',
				message:  "Please Enter Remark"
			})
			return;
		}
		post(`/vendor/invoiceDiscounting/decline`, { invoiceId: id, remarks: remark }, (e, r) => {
			if (r) {
				showToast({
					type: 'success',
					message: r.message ? r.message : "Invoice Discounting Declined"
				})
			} else {
				handleError(e)
			}
			setDeclineDiscountingModal(null);
		})

	}
	const updateCostAllocation = (obj) => {
		let costAllocationAtItems = {};
		invoices && invoices.length > 0 && invoices.forEach(i => {
			if (i.costAllocations) {
				costAllocationAtItems[i.id] = i.costAllocations
			}
		})
		let costAllocationPayload = {
			costAllocation: {
				...obj,
				costAllocationAtItems
			}
		}
		post(`/vendor/invoicing/${id}/invoicing.costAllocation.update`, costAllocationPayload, (e, r) => {
			if (r) {
				showToast({
					type: 'success',
					message: 'Cost Allocation Updated Successfully'
				})
		ALLOCATION && ALLOCATION.current && ALLOCATION.current.INIT()
		setEnableEditCostAllocation(false)
			} else if(e) {
				handleError(e)
			}
		})
	}

	if(props && props.details && props.details.tags && props.details.tags['po.pr_iom'] &&  (props.details.tags['po.pr_iom'] === 'IOM')){
		dependentmasterValue={...dependentmasterValue,"po_id":"no"}
	}

	return (
		<SidePane button={false} onClose={() => props.onClose(false)}
				  column={
					  <div style={{ width: '100%' }}>
						  <div style={{ display: 'flex' }}>
							  <ToggleSwitch2 style={{ justifyContent: 'flex-start' }} checked={invoicePreview} callback={setInvoicePreview} size="S" label="View Original Invoice" />
						  </div>
						   {invoicePreview ?
							  <div style={{ marginTop: 10 }}>
								  {details && details.invoice && details.invoice.files && details.invoice.files.map(renderFiles)}
							  </div>
							  :
							  <Invoice
								  allowTdsAtLineItem={allowTdsAtLineItem}
								  ennableOnTaxation={ennableOnTaxation}
							  	  details={details}
								  approvalStatus={approvalStatus}
							      dependentmasterValueLineItem={dependentmasterValueLineItem}
								  updateLineItemCustomForm={updateLineItemCustomForm}
								  adjustedInvoice={adjustedInvoice}
								  tdsSlabs={tdsSlabs}
								  budgetingV2={budgetingV2}
								  disableRcm={disableRcm}
								  additionalCharges={details.taxInformation && details.taxInformation.additionalCharges ? details.taxInformation.additionalCharges : []}
								  onReload={onReload}
								  tdsAtLineItem={tdsAtLineItem}
								  tdsAtLineItemInContract={tdsAtLineItemInContract}
								  tdsAtLineItemAutomation={tdsAtLineItemAutomation}
								  disableUpdate={disableUpdate && ![BAJAJ_ZRNT_CATEGORY,BAJAJ_ZRNT_CATEGORY_PROD].includes(details.invoice.categoryId)}
								  status={details.status}
								  data={{
									  singleLine: details.tags['inv_type'],
									  enableAddLineItem: enableAddLineItem && (!details.po || !details.po.length) && !disableUpdate,
									  enableLineItemPlugin: enableAddLineItem,
									  vendor: details.vendor.name,
									  panStatus: details.vendor.panStatus,
									  vendorCode: details.vendor.registeredId,
									  panNumber: details.vendor.pan,
									  vendorAddress: details.vendor.address,
									  email: details.vendor.email,
									  vendorDetails: details.vendor,
									  rcVendor: details.vendor.rcVendor,
									  vendor_id: details.vendor.gstin,
									  date: details.invoice.date,
									  due: details.dueOn ? details.dueOn : undefined,
									  Invoice_id: details.invoice.invoiceId,
									  bill_add: details.address.address,
									  bill_add_full: details.address,
									  ship_add: details.deliverTo.address,
									  bill_to: details.address,
									  ship_to: details.deliverTo,
									  bill_to_gstin: billGstIn,
									  debitNote,
									  debitNoteDetails,
									  rcInvoice: details.invoice.rcInvoice || isRcm || (details && details.tags && details.tags.rcm && details.tags.rcm==="true"),
									  enableCostAllocation: enableCostAllocation,
									  poNumber: props.details && props.details.po && props.details.po.poId,
									  multiPo: props.details && props.details.po && isArray(props.details.po) ? props.details.po.reduce((acc, current) => {
										  if (!acc.some(item => item.poId === current.poId)) {
											  acc.push(current);
										  }
										  return acc;
									  }, []) : null,
									  poId: props.details && props.details.po && props.details.po.id,
									  grnNos: grnNos,
									  creditNoteTotal: parsed && parsed.creditNoteTotal,
									  debitNoteTotal: parsed && parsed.debitNoteTotal,
									  isDebitNote: parsed && parsed.debitNote,
									  isCreditNote: parsed && parsed.creditNote,
									  vendorId: details.vendor.id,
									  table: [
										  ...invoices.map((item => {
											  return ({
												  poInvoiceMismatchReason: (item && item.poInvoiceMismatchReason) ? item.poInvoiceMismatchReason : "",
												  glCode:item.glCode,
												  autoBudgeting: (item.attrs && item.attrs.autoBudgeting) ? item.attrs.autoBudgeting : "yes",
												  desc: item.name ? item.name : item.service,
												  service: item.service,
												  price: item.price,
												  qtty: item.qtty,
												  base_amt: item.base,
												  gross_amt: item.base - (item.base * (details.taxInformation.discount / 100)),
												  tax_amt: item.tax,
												  taxSlab: item.taxSlab,
												  amount: item.amount,
												  total: item.amount,
												  hsn: item.hsn,
												  productId: item.productId,
												  cessAmount: item.cessAmount ? item.cessAmount : 0,
												  debitQty: item.debitQty ? item.debitQty : 0,
												  gstNonCreditable: item.gstNonCreditable || false,
												  costAllocations: item.costAllocations || [],
												  isAllocationAvailable: item.costAllocations && item.costAllocations.length ? true : false,
												  notes: item.notes ? item.notes : undefined,
												  id: item.id,
												  forms: item.data,
												  referenceId: item.referenceId || undefined,
												  orderId: item.orderId,
												  rcItem: item.rcItem,
												  unit: item.unit,
												  budget_id: item.attrs ? item.attrs.budget_id : undefined,
												  budget_status: item.attrs ? item.attrs.budget_status : undefined,
												  budgeted_amount: item.attrs ? item.attrs.budgeted_amount : undefined,
												  reverse_budget_id: item.attrs ? item.attrs.reverse_budget_id : undefined,
												  reverse_budget_status: item.attrs ? item.attrs.reverse_budget_status : undefined,
												  reverse_budgeted_amount: item.attrs ? item.attrs.reverse_budgeted_amount : undefined,
												  tds: (item.tdsAmount || item.tdsRate) && {
													  tdsId: item.tdsId,
													  tdsAmount: item.tdsAmount ? item.tdsAmount : "-",
													  tdsCode: item.tdsCode,
													  tdsRate: item.tdsRate,
													  tdsDesc: item.tdsDesc,
												  },
												  attrs: item.attrs,
												  serviceDesc:item.serviceDesc||'',
												  serviceAttrs:item.serviceTags||{},
												  violations: item.violations,
												  ocrData: item.ocrData,
												  cessPercent:item.cessPercent||0,
												  aiTdsSuggestion:item.aiTdsSuggestion||{}
											  })
										  }))
									  ],
									  cgst: details.taxInformation.cgst,
									  gst: details.taxInformation.gst,
									  sgst: details.taxInformation.sgst,
									  igst: details.taxInformation.igst,
									  tds: details.taxInformation.tds,
									  tcs: details.taxInformation.tcs ? details.taxInformation.tcs : 0,
									  total_tax: details.taxInformation.gst,
									  total_base: details.taxInformation.baseAmount,
									  roundOff: details.taxInformation.roundOff,
									  total_amt: details.taxInformation.tcs? (details.taxInformation.total - details.taxInformation.tcs) : details.taxInformation.total,
									  payable_amt: details.taxInformation.paidAmount,
									  discount: details.taxInformation.discount || 0,
									  discountAmount: details.taxInformation.discountAmount || 0,
									  cessAmount: details.taxInformation.cessAmount,
									  creditNoteTds: parsed.creditNoteTds || 0,
									  status: details.status,
									  settlement: Settlements ? Settlements.settled : true,
									  allSettlement: Settlements ? Settlements.settlements : [],
									  mSettlement: Settlements ? Settlements : false,
									  costAllocationDone: costAllocationDone ? costAllocationDone : false,
									  invoiceStatus: details.status,
									  systemInvoiceId: details.invoice.id,
									  categoryId: details.invoice.categoryId,
									  category: details.invoice.category,
									  asn: details.asn ? details.asn : null,
									  totalAdditionalCharge: details.taxInformation && details.taxInformation.totalAdditionalCharge ? details.taxInformation.totalAdditionalCharge : 0,
									  baseAdditionalCharge: details.taxInformation && details.taxInformation.baseAdditionalCharge ? details.taxInformation.baseAdditionalCharge : 0,
									  grossAdditionalCharge: details.taxInformation && details.taxInformation.grossAdditionalCharge ? details.taxInformation.grossAdditionalCharge : 0,
									  additionalChargesTds: details.taxInformation && details.taxInformation.additionalChargesTds ? details.taxInformation.additionalChargesTds : 0,
									  contractId: details.contractId,
									  digitallySigned:details.invoice.digitallySigned,
									  amountAdjustedAgainstDeposit:(details.taxInformation && details.taxInformation.amountAdjustedAgainstDeposit) ? details.taxInformation.amountAdjustedAgainstDeposit : 0,
									  currencyExchangeRate: (details && details.invoice && details.invoice.currencyExchangeRate)?details.invoice.currencyExchangeRate:"",
									  baseCurrencyAmount: details.invoice.baseCurrencyAmount,
								  }}
								  updateAllocation={(items, type, index) => {
									  let allInvoice = [...invoices];
									  allInvoice[index].costAllocations = items[index].costAllocations;
									  setAllocationType(type);
									  setInvoices(allInvoice)
								  }}
								  reload={onReload}
								  onlyLineItemCostAllocationAllowed={['ANAROCK','ANRCK'].includes(tenant) && (details.status === 'TAXATION_APPROVAL')}
								  init={() => {
									  props.onReload()
									  if (costAllocationDone) {
										  ALLOCATION.current.INIT();			// initiate allocation again
									  }
									  fetchInvoiceCategoryForm();
									  fetchInvoiceLineItemForm();
								  }}
							  />
						  }
				</div>
			}>
			<div className='FadeRight-Effect' style={{ fontSize: '12px', width: '100%', minWidth: '400px' }}>
				<div style={{ display: 'flex', alignItems: 'center', marginBottom: 35 }}>
					<div style={{ flex: 2 }}>
						<div style={{ fontWeight: 600, fontSize: '18px', lineHeight: '1.3' }}>Invoice</div>
						<div style={{
							color: 'var(--text-color)',
							fontWeight: 600,
							fontSize: '24px',
							lineHeight: '1.3'
						}}>{details.invoice.counterId}</div>
					</div>
					{details.invoice.files.length ?
						<div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
							<div onClick={() => setAttachmentMode(!attachmentMode)} style={{ background: 'var(--primary-color)', cursor: 'pointer', color: '#fff', padding: '5px 10px', borderRadius: 4, ...attachmentMode ? { background: '#000' } : {} }}>{attachmentMode ? 'Disable View' : 'Image View'} </div>
						</div>
				: null}
				</div>
				<MultiFlags flags={customFlags} />

				
				{props.invoiceDiscounting  
				&& config.invoiceDiscountingConfig && config.plugins.invoiceDiscountingV2 &&
				 <div style={{fontSize: '12px',background: '#FDF0DD', borderRadius: '6px', marginTop: '20px', marginBottom : '24px', padding: '12px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
				<div style={{  }}>
					<p style={{ fontSize: '14px', fontWeight: 'bold'}} >Discounting initiated at the rate of {config.invoiceDiscountingConfig.rate}%</p>
					<p style={{ fontSize: '12px'}} >(Refer Invoice Discounting)</p>
						</div>	

					{ (props.type === "invoiceDiscounting" ||  props.type === "vendorSettlements") && details.discountingData.status === "FINANCE" && <div style={{ gap: "14px", display: "flex" }}>
					<span
						style={{ fontWeight: 600, fontSize: "16px", color: "#027A48", cursor: 'pointer' }}
						onClick={(e) => {
							e.stopPropagation();
							setApproveDiscountingModal(details);
						}}
					>
						Approve
					</span>
					<span
						style={{ fontWeight: 600, fontSize: "16px", color: "#B42318", cursor: 'pointer' }}
						onClick={(e) => {
							e.stopPropagation();
							setDeclineDiscountingModal(details);
						}}
					>
						Decline
					</span>
				</div>}
				</div>						
				}
				{
					VENDOR && VENDOR.gstReturnStatus && 
					<Notification type="Warning" message={<><p>GST Return Status: {VENDOR.gstReturnStatus}</p><p style={{fontSize:10,color:'black',marginTop:5}}>Gst Returns Fetched At: {VENDOR.gstReturnsFetchedAt ? Moment(VENDOR.gstReturnsFetchedAt).format('DD-MM-YYYY') : '-'}</p><p style={{fontSize:10,textDecoration:'underline',color:'var(--primary-color)',marginTop:5,cursor:'pointer'}} onClick={() => HISTORY.push(`/app/vendor/contacts/${VENDOR.id}/setting`)}>Sync GST Returns</p></>} onClick={() => {}}/>
				}
				{
					(dueDate && !['CANCELLED', 'DECLINED', 'COMPLETED'].includes(props.details.status)) ?
						(moment(dueDate).diff(moment(), 'days') < 0) ?
							<Notification
								type="Warning"
								message={<>
									<p>
										Invoice has crossed due the date {dueDate && moment(dueDate).format('DD-MM-YYYY')}
									</p>
								</>
								}
								onClick={() => { }}
							/>
						: (moment(dueDate).diff(moment(), 'days') === 0) ?
							<Notification
								type="Warning"
								message={<>
									<p>
										Invoice is due on today {dueDate && moment(dueDate).format('DD-MM-YYYY')}
									</p>
								</>
								}
								onClick={() => { }}
							/>
							: (moment(dueDate).diff(moment(), 'days') > 0) ?
								<Notification
									type="Warning"
									message={<>
										<p>
									    	Due date: {moment(dueDate).format('DD-MM-YYYY')} (Remaining: {moment(dueDate).diff(moment(), 'days')} days)
										</p>
									</>
									}
									onClick={() => { }}
								/>
								: null
					: null
				}

				{

					attachmentMode ?
						<ViewAttachment items={details.invoice.files} />
						:
						<>
							<TabSwtich grow={true} tabs={tabs} />
						  {getTab === 10 ? (
							<div id="Invoice_Format" className='FadeRight-Effect' style={{ position: 'relative', paddingBottom: 100 }}>
							
									{
										!!creditNotes.length &&
										creditNotes.map((item, index) => {
											return (
												<div onClick={() => props.setCreditId(item.id)} key={index} style={{ backgroundColor: '#e4e1ec', display: 'flex', justifyContent: 'space-between', cursor: 'pointer', padding: '15px', marginBottom: 10, borderRadius: 8, marginTop:'20px' }}>
													<div >
														<p style={{ fontSize: 14, fontWeight: 'bold' }}>{item.creditNoteId}</p>
														<p style={{ fontSize: 12 }}>Amount :{item.currency} {item.amount}</p>
														<p style={{ fontSize: 12 }}>Created At : {Moment(item.date).format('DD-MM-YYYY')}</p>
													</div>
													<div>
														<p style={{ background: 'rgb(13, 110, 253)', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 11, padding: '4px 10px', color: "#fff", borderRadius: 4 }}>{item.status}</p>
													</div>
												</div>

											)
										})
									}
									{
										creditNote && (details.status!== 'DECLINED' && details.status !== 'FAILED' && details.status !== 'CANCELLED' && details.status !== "CREDIT_NOTE_HOLD")?
										<div onClick={()=>{
											const status=details.status;
											if(restrictCnBeforeGrnSync && (status === "POHOLD")){
												showToast({
													type:'error',
													message:"You can't create credit note before GRN sync"
												})
												return ;
											}
											props.submitCreditNote({label:details.id,value:details.invoice.counterId})
										}} style={{
											boxShadow:'rgb(1 1 1 / 2%) 4px 5px 3px',
											background:'rgb(240, 112, 24)',
											cursor:'pointer',
											border:'1px solid var(--border-color)',
											borderRadius:8,
											width:150,
											fontSize:12,
											textAlign:'center',
											padding:'10px 12px',
											color:"#fff",
											marginTop:20
										}}>
											+ Create Credit Note
									  	</div>
										:null
									}
							</div>
							) : null}
							{getTab === 11 ? (
							<div id="Invoice_Format" className='FadeRight-Effect' style={{ position: 'relative', paddingBottom: 100 }}>
								{
										!!debitNotes.length &&
										debitNotes.map((item, index) => {
											return (
												<div onClick={() => props.setDebitId(item.id)} key={index} style={{ backgroundColor: '#e4e1ec', display: 'flex', justifyContent: 'space-between', cursor: 'pointer', padding: '15px', marginBottom: 10, borderRadius: 8, marginTop:'20px' }}>
													<div >
														<p style={{ fontSize: 14, fontWeight: 'bold' }}>{item.debitNoteId}</p>
														<p style={{ fontSize: 12 }}>Amount :{item.currency} {item.amount}</p>
														<p style={{ fontSize: 12 }}>Created At : {Moment(item.createdAt).format('DD-MM-YYYY')}</p>
													</div>
													<div>
														<p style={{ background: 'rgb(13, 110, 253)', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 11, padding: '4px 10px', color: "#fff", borderRadius: 4 }}>{item.status}</p>
													</div>
												</div>

											)
										})
								}
								{
										debitNotePlugin && (details.status!== 'DECLINED' && details.status !== 'FAILED' && details.status !== 'CANCELLED' && details.status !== "DEBIT_NOTE_HOLD")?
										<div  onClick={()=>{
											props.submitDebitNote({label:details.id,value:details.invoice.counterId})
										}}  style={{
											boxShadow:'rgb(1 1 1 / 2%) 4px 5px 3px',
											background:'rgb(240, 112, 24)',
											cursor:'pointer',
											border:'1px solid var(--border-color)',
											borderRadius:8,
											width:150,
											fontSize:12,
											textAlign:'center',
											padding:'10px 12px',
											color:"#fff",
											marginTop:20
										}}>
											+ Create Debit Note
									  	</div>
										:null
									}
							</div>
							) : null}
							{getTab === 1 ?
								<div id="Invoice_Format" className='FadeRight-Effect' style={{ position: 'relative', paddingBottom: 100 }}>
									{integrationData && _.size(integrationData) > 0 && integrationData['postingSynced'] && (
										<div style={{ display: 'flex', marginTop: 10, justifyContent: 'flex-end', alignItems: 'center' }}>
											<div style={{ padding: '4px 8px', borderRadius: '5px', fontSize: '11px', color: '#fff', display: 'inline-flex', marginTop: '5px', background: 'rgb(78 185 135)' }}>Posting Synced successfully</div>
										</div>
									)}

									<div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
									{_.includes(BAJAJ, tenant) && (details && details.integration && details.integration.postingFailed && details.integration.postingTriggered) &&
										<div onClick={() => {
											setRepost(true)
										}} style={{
											boxShadow: 'rgb(1 1 1 / 2%) 4px 5px 3px',
											background: 'rgb(240, 112, 24)',
											cursor: 'pointer',
											border: '1px solid var(--border-color)',
											borderRadius: 8,
											width: 150,
											fontSize: 12,
											textAlign: 'center',
											padding: '10px 12px',
											color: "#fff",
											marginTop: 20
										}}>
											Re-Post Invoice
										</div>
									}
									{
										_.includes(BAJAJ,tenant) && (details && details.tags && details.tags.ses_triggered && (!details.tags.ses_no) ? details.tags.ses_triggered.toLowerCase() === 'true' : false) ?
										<>
										<div onClick={() => {
											axios.create()({
												method:'POST',
												url:`${getBaseUrl().replace(/\/admin\/?$/, '')}/apis/external/invoice/updateInvoiceAttr`,
												data:{
													invoiceId: details && details.invoice && details.invoice.counterId ? details.invoice.counterId  : null,
													data: { ses_triggered: false }
												},
												headers:{
													'Content-Type': 'application/json',
													'DICE-APP-ID': 'BAJAJELECT',
													'X-CLIENT-ID': '069fb23e8',
													'X-CLIENT-SECRET': '361c89e3f0c34e849142c8008b535cf1'
												}
											})
											.then(() => {
												onReload();
												showToast({
													type:'success',
													message:"SES re-triggered successfully"
												})
											})
											.catch((err) => {
												showToast({
													type:'error',
													message:(err && err.data && err.data.message) || (err && err.message) || 'Failed to re-trigger SES'
												})
											})
										}} style={{
											boxShadow: 'rgb(1 1 1 / 2%) 4px 5px 3px',
											background: 'rgb(140, 111, 24)',
											cursor: 'pointer',
											border: '1px solid var(--border-color)',
											borderRadius: 8,
											width: 200,
											fontSize: 12,
											textAlign: 'center',
											padding: '10px 12px',
											color: "#fff",
											marginTop: 20
										}}>
											Re-Trigger SES
										</div>										 
										</>
										:null
									}
									</div>
									{
										_.includes(BAJAJ,tenant) && !utilities ?
										<>
										<div onClick={() => {
											post(`vendor/invoicing/${id}/syncInvoiceToAutoTagGrn`,{},(e,r)=>{
												if(r) {
													onReload();
													showToast({
														type:'success',
														message:"Invoice Sync successfully"
													})
												} else {
													showToast({
														type:'error',
														message:e.data.message
													})
												}
											})
										}} style={{
											boxShadow: 'rgb(1 1 1 / 2%) 4px 5px 3px',
											background: 'rgb(140, 111, 24)',
											cursor: 'pointer',
											border: '1px solid var(--border-color)',
											borderRadius: 8,
											width: 200,
											fontSize: 12,
											textAlign: 'center',
											padding: '10px 12px',
											color: "#fff",
											marginTop: 20
										}}>
											Sync Invoice to Auto Tag GRN
										</div>										 
										</>
										:null
									}

									{
										Settlements && Settlements.advances && Settlements.advances.length  ?
										<div style={{ fontSize: '12px', background: '#FDF0DD', borderRadius: '4px', marginTop: '20px', padding: '10px', display: 'flex', alignItems: 'center', border:'1px solid rgb(144 150 38 / 57%)' }}>
											<svg style={{ marginRight: 12 }} xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 16 16">
												<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
												<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
											</svg>
											<span style={{fontSize:'medium', display:'flex'}} >
											This vendor has an open advance .
											</span>
										</div>
										:null
									}
									
									{vendorStatus==='BLOCKED' && <div style={{ fontSize: '12px', background: '#FDF0DD', borderRadius: '4px', marginTop: '20px', padding: '10px', display: 'flex', alignItems: 'center', border:'1px solid rgb(144 150 38 / 57%)' }}>
										<svg style={{ marginRight: 12 }} xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 16 16">
											<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
											<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
										</svg>
										<span style={{fontSize:'medium', display:'flex'}} >
											This Vendor is Blocked. 
										</span>
									</div>}

									{
										costAllocation && !costAllocationDone && ennableOnTaxation ?
											<div style={{
												marginTop: 20
											}}>
												<ToggleSwitch status={enableCostAllocation} callback={setEnableCostAllocation} label='Add Cost Allocation to Invoice' />
											</div>
											: null
									}
									{
										details.status === 'POHOLD' ?
											<div style={{ fontSize: '12px', background: '#FDF0DD', borderRadius: '6px', marginTop: '20px', padding: '20px', width: '100%', display: 'flex', alignItems: 'center' }}>
												<svg style={{ marginRight: 10, fontSize: '16px' }} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
													<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
													<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
												</svg>
												<span>This Invoice is on hold because of possible reason <br></br>
													<b> {grn.length>0 ? "1. Partial GRN is pending":"1. GRN is pending"} </b>. <br></br>
													<b>2. Check Bill Number in Dice and Original Invoice</b>.
													</span>
											</div>
											: <></>
									}

							       {
							 			(details.status === 'APPROVAL' || details.status === 'COMPLETED') &&  props.details && props.details.po && props.details.po.length>0 ?
											<div style={{ fontSize: '12px', background: '#FDF0DD', borderRadius: '6px', marginTop: '20px', padding: '20px', width: '100%', display: 'flex', alignItems: 'center' }}>
												<svg style={{ marginRight: 10, fontSize: '16px' }} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
													<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
													<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
												</svg>
												<span> 
													<b>Three way match completed</b>.
													</span>
											</div>
											: <></>
									}



									{
										details.duplicates && details.duplicates.length ?
											<>
												<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 15px 0px' }}>Duplicate Voucher Id</div>
												{details.duplicates.map((item) => {
													return (
														<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>
															<svg style={{ fontSize: '14px', marginRight: '10px', verticalAlign: 'middle', color: '#fd7e14', marginBottom: '2px' }} className="bi bi-exclamation-triangle-fill" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
																<path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>
															</svg>
															{item}</span>
														</div>
													)
												})}
											</>
											: null
									}
									   {
											ocrData && Object.keys(ocrData).length  ?
										<div>
											<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>OCR data </div>
										 	<OcrTableContainer details={ocrData} onClick={setViewOcr} />
											{/* {Object.keys(ocrData).map((key, index) => {
											if(key === "originalOcr"){
												return <></>
											}
											else if (key !== 'success' && key !== 'sellerGst') {
												return (
													<p key={index}>
														{key}: <span>{ocrData[key]}</span>
													</p>
												);
											} else if (key === 'sellerGst') {
												return (
													<p key={index}>
														{ocrData[key].split('\n')[1]}
													</p>
												);
											}
											return null;
										})} */}
										</div>
										
										: null
									}
									 {
										ocrV2Data && Object.keys(ocrV2Data).length  ?
										<div>
											<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>OCR data
									       </div>
										    <OcrTableContainer details={ocrV2Data} onClick={setViewOcr} />
											{/* {Object.keys(ocrV2Data).map((key, index) => {
												if(key === "raw" || key === "invoiceItems" || key === "irnQrCodeData") return <></>
											if (key !== 'success' && key !== 'sellerGst') {
												return (
													<p key={index}>
														{key}: <span>{ocrV2Data[key]}</span>
													</p>
												);
											} else if (key === 'sellerGst') {
												return (
													<p key={index}>
														{ocrV2Data[key].split('\n')[1]}
													</p>
												);
											}
											return null;
										})} */}
										</div>
										
										: null
									}
									 {ocrMismatches && ocrMismatches.length ? 
										<div>
										<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>OCR Mismatches
									    </div>
										{ocrMismatches.map((e) =>(
											<div  key={e} style={{ marginTop: '5px' }}>
											 {e}
											</div>
										  ))}
										</div>							
									  : null 
									 }
									<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Details
									</div>
									<div style={{ marginTop: '5px' }}><span
										style={{ color: 'var(--text-color)', marginRight: '3px' }}>Invoice Number:</span>{details.invoice.invoiceId}
									</div>
									<div style={{ marginTop: '5px' }}><span
										style={{ color: 'var(--text-color)', marginRight: '3px' }}>Category:</span> {details.category}</div>
									<div style={{ marginTop: '5px' }}><span style={{
										color: 'var(--text-color)',
										marginRight: '3px'
									}}>Amount:</span> {`INR ${numberWithCommas(details.invoice.amount)}`}</div>
									{details.superName && <div style={{ marginTop: '5px' }}><span style={{
										color: 'var(--text-color)',
										marginRight: '3px'
									}}>Super Category:</span> {details.superName}</div>}
									{details.entity && details.entity.name &&  <div style={{ marginTop: '5px' }}><span style={{
										color: 'var(--text-color)',
										marginRight: '3px'
									}}>
										Entity Name: </span> {details.entity.name}
									</div>
									}

									{
										(startDate&&endDate) ?
										<div style={{ marginTop: '5px' }}><span
										style={{ color: 'var(--text-color)', marginRight: '3px' }}>Invoice Period :</span>{`${moment(startDate).format("DD-MMM-YYYY")} to ${moment(endDate).format("DD-MMM-YYYY")}`}
									</div>
									:null
									}

									{details.taxInformation  && details.taxInformation && details.taxInformation.tdsCode && (
										<>
											<div style={{ marginTop: '5px' }}><span style={{
												color: 'var(--text-color)',
												marginRight: '3px'
											}}>Tds Section:</span> {details.taxInformation.tdsCode}</div>
											<div style={{ marginTop: '5px' }}><span style={{
												color: 'var(--text-color)',
												marginRight: '3px'
											}}>Tds description:</span> {(details.taxInformation && details.taxInformation.tdsDesc) ? details.taxInformation.tdsDesc: '-'}</div>
										</>
									)}
									{
										details.invoice.predictedAmount ?
											<div style={{ marginTop: '5px' }}><span style={{
												color: 'var(--text-color)',
												marginRight: '3px'
											}}>Predicted Amount:</span> {`INR ${details.invoice.predictedAmount ? numberWithCommas(details.invoice.predictedAmount.toFixed(2)) : '-'}`}</div>
											: null

									}

									{
										enableCostAllocation?
											<CostAllocation
												ref={COSTALLOCATION}
												bill_To={details.deliverTo}
                                                entityName={(details.entity && details.entity.name)||''}
												totalAmount={costAllocationOnBaseAmount?details.taxInformation.baseAmount:costAllocationOnNetPayableAmount? Number(calculateTotalPayable().toFixed(2)): details.invoice.amount}
												prevItems={[...invoices]}
												costAllocationType={allocationType}
												gstin={billGstIn}
												category={category}
												categoryId={(details && details.invoice && details.invoice.categoryId)?details.invoice.categoryId:undefined}
											/>
											: null
									}

									{
										costAllocationDone ?
											<Allocation
											    currency={details.invoice && details.invoice.currency ? details.invoice.currency : "INR"}
												logs={details.invoice.logs||[]}
												type="vendor-invoice"
												reference={details.invoice.id}
												ref={ref => ALLOCATION.current = ref}
												onReloadInvoice={()=>{onReload()}}
												disableEdit={!approvalStatus(details.status)}
												onEnableEditCostAllocation={(data)=>{setEnableEditCostAllocation(data)}}
											/>
											: null
									}
									{
										enableEditCostAllocation ?
											<EditCostAllocation
												updateEditedCostAllocation={(data)=>updateCostAllocation(data)}
												totalAmount={enableEditCostAllocation.data && enableEditCostAllocation.data.totalAllocatedAmount ?
													enableEditCostAllocation.data.totalAllocatedAmount : enableEditCostAllocation.totalAmount}
												costAllocationType={enableEditCostAllocation.data && enableEditCostAllocation.data.baseType ? enableEditCostAllocation.data.baseType : undefined}
												allocations={enableEditCostAllocation.data && enableEditCostAllocation.data.allocations ? enableEditCostAllocation.data.allocations : []}
												onReloadInvoice={() => { onReload() }}
												onClose={() => { setEnableEditCostAllocation(false) }}/>
											: null
									}
									{
										props.status === 'COMPLETED' || props.status === 'CANCELLED' ?
											<>
												<div style={{
													fontSize: '14px',
													fontWeight: 'bold',
													margin: '30px 0px 15px 0px'
												}}>Information
												</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>Vendor Name:</span> {details.vendor.name}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>Invoice Date:</span> {details.invoice.date}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>Invoice Number:</span> {details.invoice.invoiceId}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>GSTIN:</span> {details.vendor.gstin}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>Email:</span> {details.vendor.email}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>Billing Address:</span> {details.address.address}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>Shipping Address:</span> {details.deliverTo.address}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>GST:</span> {details.taxInformation.gst}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>SGST/UTGST:</span> {details.taxInformation.sgst + details.taxInformation.utgst}
												</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>CGST:</span> {details.taxInformation.cgst}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>IGST:</span> {details.taxInformation.igst}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>TDS:</span> {details.taxInformation.tds}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>Base Amount:</span> {details.taxInformation.baseAmount}</div>
												<div style={{ marginTop: '5px' }}><span style={{
													color: 'var(--text-color)',
													marginRight: '3px'
												}}>Payable Amount:</span> {details.taxInformation.paidAmount}</div>
											</>
											: <>
												<div style={{
													fontSize: '14px',
													fontWeight: 'bold',
													margin: '30px 0px 15px 0px'
												}}>Update Invoice
												</div>
												<div style={{ display: 'flex', width: '100%', alignItems: 'end' }}>
													<SearchableSelect
													 	disabled={!approvalStatus(details.status) || disableUpdate || ['BSETEST', 'ANAROCK', 'ANRCK'].includes(tenant)}
														label="Vendor Name"
														placeholder="Select vendor"
														value={getVendor}
														reset={() => {
															setSelectedVendorAddress('');
														}}
														select={vendorModal => {
															setVendor(vendorModal)
														}}
														add={{
															name: "Add New Vendor",
															link: "/app/vendor/contacts/new"
														}}
														onChange={val => {
															if (val.length > 1) {
																get(`/vendor/contacts/search?q=${val}`, (e, r) => {
																	setVendors(r.contacts.map(item => ({
																		value: item.id,
																		label: item.title,
																		des: item.email
																	})))
																})
															} else {
																setVendors([])
															}
														}}
														items={getVendors} />

													{
														(exclude || getVendor === '' || (!approvalStatus(details.status) || disableUpdate || ['BSETEST', 'ANAROCK', 'ANRCK'].includes(tenant))) ? <></> :
															<div onClick={() => {
																updateInvoice('vendor')
															}} style={{
																height: '45px',
																width: '45px',
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																fontSize: '16px',
																cursor: 'pointer',
																color: 'var(--white-color)',
																backgroundColor: 'var(--primary-color)',
																zIndex: '111',
																marginBottom: '8px',
																marginLeft: '-45px'
															}}>
																<svg className="bi bi-check-lg" xmlns="http://www.w3.org/2000/svg"
																	width="1em" height="1em" fill="currentColor"
																	viewBox="0 0 16 16">
																	<path
																		d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
																</svg>
															</div>
													}
												</div>
												<div style={{ display: 'flex', width: '100%', alignItems: 'end' }}>
												<SearchableSelect
														label="Vendor Address"
														disabled={!approvalStatus(details.status) || disableUpdate|| !writeAccessTaxation}
														placeholder="Select address"
														value={selectedVendorAddress}
														reset={() => {
															setVendorAddressFilter(vendorAddress)
														}}
														select={vendorModal => {
															setToggleAddress(true)
															setSelectedVendorAddress(vendorModal)
														}}
														onChange={val => {
															if (val.length > 1) {
																 setVendorAddressFilter(vendorAddress.filter((e) => JSON.stringify(e).toLowerCase().includes(val.toLowerCase())))
															} else {
																setVendorAddressFilter(vendorAddress)
															}
														}}
														items={vendorAddressFilter} />
														{
														(!toggleAddress)? <></> :
															<div onClick={() => {
																if(disableUpdate) return;
																updateInvoice('vendorAddress')
															}} style={{
																height: '45px',
																width: '45px',
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																fontSize: '16px',
																cursor: 'pointer',
																color: 'var(--white-color)',
																backgroundColor: 'var(--primary-color)',
																zIndex: '111',
																marginBottom: '8px',
																marginLeft: '-45px'
															}}>
																<svg className="bi bi-check-lg" xmlns="http://www.w3.org/2000/svg"
																	width="1em" height="1em" fill="currentColor"
																	viewBox="0 0 16 16">
																	<path
																		d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
																</svg>
															</div>
													}
												</div>
												<div style={{ width: '100%',  marginTop: 20 }}>
														<BankAdd disabled={disableUpdate}  id={id} vendorId={details.vendor.id} vendor={details.vendor} bank={details.vendor.bank}
														 init={() => {
															onReload()
														}}
														
														/>
													</div>
												<div style={{ display: 'flex', width: '100%', alignItems: 'end' }}>
													<SearchableSelect
														disabled={!approvalStatus(details.status) || disableUpdate|| !writeAccessTaxation}
														label="Billing Address"
														placeholder="Select Office"
														value={selectedBillAddress}
														reset={() => {
															setOffices([])
														}}
														select={office => {
															setToggleBillAddress(true)
															setSelectedBillAddress(office)
														}}
														shipTo="no"
														onChange={q => {
															if (q.length > 0) {
																let data = {q,p2p:"yes"};
																if (entityHierarchy && props.details && props.details.entityId) {
																	data["entityid"] = props.details.entityId;
																}
																get(`/search/v1/offices`, (e, r) => {
																	if (r) {
																		setOffices(r.offices.map(item => ({
																			label: item.name,
																			value: item.id,
																			gstin : (item && item.gstin)?item.gstin:""
																		})))
																	}
																}, data)
															} else {
																setOffices([])
															}
														}}
														items={getOffices} />
													{
														(!toggleBillAddress) ? <></> :
															<div onClick={() => {
																if(disableUpdate) return;
																updateInvoice('bill')
															}} style={{
																height: '45px',
																width: '45px',
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																fontSize: '16px',
																cursor: 'pointer',
																color: 'var(--white-color)',
																backgroundColor: 'var(--primary-color)',
																zIndex: '111',
																marginBottom: '8px',
																marginLeft: '-45px'
															}}>
																<svg className="bi bi-check-lg" xmlns="http://www.w3.org/2000/svg"
																	width="1em" height="1em" fill="currentColor"
																	viewBox="0 0 16 16">
																	<path
																		d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
																</svg>
															</div>
													}
												</div>
												<div style={{ width: '100%' }}>
													<FloatInputButton type="date" onSubmit={(val) => {
														updateInvoice('date', val)
														if(tenant === "DEZ" || tenant === "DEZERV" || tenant==="KARANDEVENV" || tenant==="INDIAN"){
															let categoryId = (details && details.invoice && details.invoice.categoryId)?details.invoice.categoryId:"";
															if(vendorDetails && vendorDetails.config && vendorDetails.config.paymentTerms && vendorDetails.config.paymentTerms[categoryId]){
																let paymentTerms = vendorDetails.config.paymentTerms[categoryId];
																let dueDate = Moment(val).add(paymentTerms, 'days').format('YYYY-MM-DD');
																updateInvoice('due', dueDate)
															}
															else{
																let paymentTerms = 30;
																let dueDate = Moment(val).add(paymentTerms, 'days').format('YYYY-MM-DD');
																updateInvoice('due', dueDate)
															}
														}
													}} title='Invoice Date' disabled={!approvalStatus(details.status) || exclude|| !writeAccessTaxation || details.type.toLowerCase()==="utility"} placeholder={Moment(details.invoice.date, "DD-MM-YYYY").format('YYYY-MM-DD')} />
												</div>
												<div style={{ width: '100%' }}>
													<FloatInputButton type="date" onSubmit={(val) => {
														updateInvoice('due', val)
													}} title='Due Date' disabled={!approvalStatus(details.status) || details.type.toLowerCase()==="utility"} placeholder={details.dueOn? Moment(details.dueOn).format('YYYY-MM-DD'):''} />
												</div>

												<div style={{ display: 'flex', width: '100%', alignItems: 'end' }}>
													<SearchableSelect
														label={selectedShipAddress && selectedShipAddress.shipTo === "yes" ? "Place of Supply":"Shipping Address"}
														disabled={!approvalStatus(details.status) || disableUpdate|| !writeAccessTaxation}
														placeholder="Select Office"
														value={selectedShipAddress}
														reset={() => {
															setOffices([])
														}}
														select={office => {
															setToggleShipAddress(true)
															setSelectedShipAddress(office)
														}}
														onChange={q => {
															if (q.length > 0) {
																let data = {q,p2p:"yes"};
																if (entityHierarchy &&props.details &&props.details.entityId) {
																	data["entityid"] = props.details.entityId;
																}
																get(`/search/v1/offices`, (e, r) => {
																	if (r) {
																		setOffices(r.offices.map(item => ({
																			label: item.name,
																			value: item.id,
																			gstin : (item && item.gstin)?item.gstin:"",
																			shipTo:item.shipTo
																		})))
																	}
																},data)
															} else {
																setOffices([])
															}
														}}
														items={getOffices} />
													{
														(!toggleShipAddress) ? <></> :
															<div onClick={() => {
																if(disableUpdate) return;
																updateInvoice('ship')
															}} style={{
																height: '45px',
																width: '45px',
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																fontSize: '16px',
																cursor: 'pointer',
																color: 'var(--white-color)',
																backgroundColor: 'var(--primary-color)',
																zIndex: '111',
																marginBottom: '8px',
																marginLeft: '-45px'
															}}>
																<svg className="bi bi-check-lg" xmlns="http://www.w3.org/2000/svg"
																	width="1em" height="1em" fill="currentColor"
																	viewBox="0 0 16 16">
																	<path
																		d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
																</svg>
															</div>
													}
												</div>


												<FloatInputButton onSubmit={(val) => {
													if(val && details && details.vendor && details.vendor.gstin){
														let len1=val.length;
														let len2=val.trim().length;
														if(len1!==len2){
															showToast({
																type:'error',
																message:"Invoice Number cannot have leading or trailing spaces"
															})
															return;
														}
														//eslint-disable-next-line
														const invoiceRegex = ['Purplle','PRPLTEST',"KARANDEVENV"].includes(tenant) ? /[^A-Za-z0-9\/\-_]/g : /[^A-Za-z0-9\/\-]/g;
														const cleanedBillNumber = (val || '').replace(invoiceRegex, '');
														if(cleanedBillNumber !== val){
															showToast({
																type:'error',
																message: ['Purplle','PRPLTEST',"KARANDEVENV"].includes(tenant) ? "Only alphanumeric characters, '-', '/' and '_' are allowed for GST vendors" : "Only alphanumeric characters, '-' and '/' are allowed for GST vendors"
															})
															return;
														}
													}
													if(val.length>16 && !(tenant==="SBF" || tenant==="SBFC")) {
														if(details && details.vendor && details.vendor.gstin){
															showToast({
																type:'error',
																message:"Invoice Number cannot be greater than 16 characters for GST Vendors"
															})
															return
														}
													}
													updateInvoice('id', val)
												}} title='Invoice Number' disabled={!approvalStatus(details.status) || exclude|| !writeAccessTaxation} placeholder={details.invoice.invoiceId} />

												<div style={{ display: 'flex' }}>
													<div style={{ width: '50%' }}><FloatInputButton onSubmit={(val) => {
														updateInvoice('base', val)
													}} title='Base Amount ' placeholder={details.taxInformation.baseAmount} disabled={!approvalStatus(details.status) || (po || (props.details && props.details.po && isArray(props.details.po) && props.details.po.length>0)) || disableUpdate} />
													</div>
													{/* Header level tds removed for Incred + tdsAtLineItemAutomation enabled */}
												{allowTdsAtHeader && ((details.po && details.po.length) || (details.contractId && !tdsAtLineItemInContract) || (!details.contractId && !tdsAtLineItemAutomation) || (!details.contractId && !tdsAtLineItem)) && !((tenant==="INCRED" || tenant==="INCRD") && tdsAtLineItemAutomation) &&
													<div style={{ width: '50%', paddingLeft: '10px', marginTop: 20 }}>
														<Tds entityId={(details && details.entityId)?details.entityId:""} billDate={details.invoice.billDate}  vendor={details.vendor} id={id} vendorId={details.vendor.id} value={details.taxInformation.tds} init={() => {
															onReload()
														}}
															disabled={!approvalStatus(details.status) || (disableUpdate && ![BAJAJ_ZRNT_CATEGORY,BAJAJ_ZRNT_CATEGORY_PROD].includes(details.invoice.categoryId))}
														/>
													</div>
													}
												</div>
												<div style={{ display: 'flex' }}>
													<div style={{ width: '33%' }}><FloatInputButton onSubmit={(val) => {
														updateInvoice('sgst', val)
													}} title='SGST / UTGST '
														placeholder={details.taxInformation.sgst ? details.taxInformation.sgst.toFixed(2) : details.taxInformation.sgst}
														disabled={!approvalStatus(details.status) || !SGstEnable || (po || (props.details && props.details.po && isArray(props.details.po) && props.details.po.length>0)) || disableUpdate|| !writeAccessTaxation}
													/>
													</div>
													<div style={{ width: '33%', paddingLeft: '10px' }}><FloatInputButton
														
														onSubmit={(val) => {
															updateInvoice('igst', val)
														}} title='IGST ' placeholder={details.taxInformation.igst ? details.taxInformation.igst.toFixed(2) : details.taxInformation.igst} 
														disabled={!approvalStatus(details.status) || disableUpdate || (SGstEnable  && vendorGstIn && billGstIn && !(['TGRANAL','TGRANL'].includes(tenant) && (details.invoice && details.invoice.category === 'Travelling Expenses'))) || (po || (props.details && props.details.po && isArray(props.details.po) && props.details.po.length>0))} /></div>
													<div style={{ width: '33%', paddingLeft: '10px' }}>
														<FloatInputButton
														onSubmit={(val) => {
															updateInvoice('cgst', val)
														}} title='CGST' placeholder={details.taxInformation.cgst ? details.taxInformation.cgst.toFixed(2) : details.taxInformation.cgst} disabled={!approvalStatus(details.status) || disableUpdate || !SGstEnable|| (po || (props.details && props.details.po && isArray(props.details.po) && props.details.po.length>0))} /></div>
												</div>
												<FloatInputButton onSubmit={(val) => {
													if(val<0){
														showToast({
															type: "error",
															message: "Value cannot be negative",
														  });
														  return;
													}else if(val>90){
														showToast({
															type: "error",
															message: "Value cannot be greater than 90",
														  });
														  return;
													}else updateInvoice('discount', val)
												}} title='Discount Percentage' disabled={!approvalStatus(details.status) || disableUpdate|| !writeAccessTaxation} placeholder={numberWithCommas(details.taxInformation.discount)} />
												
												<FloatInputButton onSubmit={(val) => {
													if(val){
														let value = parseFloat(val);
														let discountPerct = (value*100)/parseFloat(details.taxInformation.baseAmount);
														if(value<0){
															showToast({
																type: "error",
																message: "Value cannot be negative",
															  });
															  return;
														}else if(discountPerct>90){
															showToast({
																type: "error",
																message: "Value cannot be greater than 90",
															  });
															  return;
														}else updateInvoice('discount', discountPerct.toString())
													}
												}} title='Discount Amount' disabled={!approvalStatus(details.status) || disableUpdate|| !writeAccessTaxation} placeholder={numberWithCommas(details.taxInformation.discountAmount)} />
												<div style={{marginTop:"5px"}}>
													<FloatInputButton 
													    onSubmit={(val)=>{
															if(val){
																let value = parseFloat(val);
																if(value < 0){
																	showToast({
																		type: "error",
																		message: "Value cannot be negative",
																	  });
																	  return;
																}
																else{
																	updateInvoice('tcs', val)
																}
															}
														}}
													    placeholder={numberWithCommas(details.taxInformation.tcs)}
														title="TCS (Tax Collected at Source)"
														type="number"
													/>
												</div>
												<FloatInputButton onSubmit={(val) => {
													 if(val>Number(invoiceRoundOfAmountLimit) || val < (Number(invoiceRoundOfAmountLimit)*-1)) {
														showToast({
															type:'error',
															message:`RoundOff amount is not allowed greater than ${Number(invoiceRoundOfAmountLimit)} or lesser then -${Number(invoiceRoundOfAmountLimit)}`
														})
														return
													 } 
													updateInvoice('roundOff', val)
												}} title='RoundOff' disabled={!approvalStatus(details.status) || disableUpdate|| !writeAccessTaxation} placeholder={details.taxInformation.roundOff} />
											</>
									}
								 {!disableRcm && checkRCMStatusonLineItem(invoices) && ennableOnTaxation &&
									<div style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'flex-start',
										marginTop: 20,
									}}>
										<input onClick={() => {
											if(['TESTASK','ASK'].includes(tenant) && details.taxInformation && details.taxInformation.gst === 0 && !rcm) {
												showToast({
													type: 'error',
													message: "Tax Amount is 0, so RCM Invoice is not allowed"
												})
												setRcm(false)
												return;
											}
											if(['TESTASK','ASK'].includes(tenant) && !rcm){
												let check=checkGstAtLineItem();
												if(!check){
													showToast({
														type: 'error',
														message: "GST is not applied on all the line items"
													})
													setRcm(false)
													return;
												}
											}
											if (disableUpdate) return;
											onRcmChange(!rcm)
										}} type='checkbox' checked={rcm}
											style={{
												height: 22,
												width: 22
											}}
										/>
										<p style={{
											minHeight: 35,
											fontSize: 13,
											color: "var(--text-color)",
											borderRight: '2px solid var(--border-color)',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											marginLeft: 10,
											fontWeight: 600,
										}}>
											{'RCM Invoice'}
										</p>
									</div>
									}
									{
										['APPROVAL','TAXATION_APPROVAL'].includes(details.status) && InvoiceForm.length > 0 && prefill && 
										<>
											<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>
												{props.details.tags && props.details.tags['inv_type']?props.details.tags['inv_type']==='single'?'Invoice Service Form':'Invoice Category Form':'Invoice Category Form'}
											</div>
											<MapInvoiceForm/>
										</>
									}
									<div
										style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 15px 0px' }}>Attachment
									</div>
									<div style={{
										display: 'flex',
										marginLeft: '-15px',
										flexWrap: 'wrap',
										maxHeight: '250px',
										overflowY: 'scroll'
									}}>

										{(!exclude) && ennableOnTaxation? <ReadOnly> <MultipleAttachmentUploaderModal onUpload={filesData => {
											let count = 0;
											filesData.forEach(async (i, index) => {
												setTimeout(async () => {
													await post(`/vendor/invoicing/${id}/attachment`, { file: i.url, name: i.name }, (e, r) => {
														if (r) {
															count++;
															if (count === filesData.length) {
																onReload();
																showToast({
																	type: 'success',
																	message: 'File uploaded'
																})

															}

														} else if (e) {
															handleError(e);
														}
													});
												}, index * 100)

											})
										}} /> </ReadOnly>:null}

										{
											details.invoice.files.length > 0 ?
												<>
													{
														details.invoice.files.map((item, index) => {
															return (
																<div>
																	<PhotoTile key={`Photo-${index}`} 
																	link={item} 
																	// Delete attachment only added for spacial case.
																	// onDelete={(val) =>{
																	// 	post(`/settlements/vendor/invoices/${id}/attachment.remove`, { file: item }, (e, r) => {
																	// 		if (r) {
																	// 				onReload();
																	// 				showToast({
																	// 					type: 'success',
																	// 					message: 'File uploaded'
																	// 				})
																	// 		}
																	// 	});
																	// }}
																  />
																	<p style={{ textAlign: 'center', fontSize: 10, fontWeight: 'bold' }}># {index + 1}</p>
																</div>
															)
														})
													}


												</>

												: <></>
										}


									</div>
									{
										tdsCertificates && Array.isArray(tdsCertificates) && tdsCertificates.length > 0 ?
											<>
												<p style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>LDC Certificates</p>
												<div style={{ display: 'flex' }}>
													{
														tdsCertificates.map((item, index) => {
															return (
																<div>
																	<PhotoTile key={`Photo-${index}`}
																		link={item.tdsCertificateAttachment}
																	/>
																</div>
															)
														})
													}
												</div>
											</>
											: <></>
									}
									<PhotoName attachments={details.invoice.files} fileNames={details.invoice.fileNames} />
									{(showBulkUpdate && ['bajajelec'].includes(tenant) && status==="APPROVAL" && details && details.invoice && details.invoice.items && details.invoice.items.length>0)?<div style={{width:'100%',display:'flex',justifyContent:'flex-end'}}>
										<p
											onClick={()=>{
												setLineItemsSelectModal(true);
											}}
											className="btn btn-portlet"
											style={{
												width: '150px',
												fontSize: '9px',
												padding: '4px 0px',
												margin: '0 10px 10px 0',
											}}
										>
											{"Bulk Update Custom Form"}
										</p>
									</div>:null}
									{approvalStatus(status) &&
											<LineItemForms />
									
									}

									{
										approvalStatus(status) ?
											<div>
												<Form 
												initialValues={{...categoryFormMap,...prefill}} 
												dependentKeyValue={{...dependentmasterValue,...dependentField}}
												masterKeyValue={dependentmaster} 
												handler={ref => FORM.current = ref} 
												onChange={onChangeCatrgotyForm}
												/>
												{status === 'TAXATION_APPROVAL' && (
												<Form 
												label={"Taxation Additional Details"}
												handler={ref => TAXATION_CATEGORY_FORM.current = ref} 
												onChange={onChangeCatrgotyForm}
												/>
												)}
											</div>
											: null
									}
									{
										(status === 'TAXATION_APPROVAL' && pathname.includes('taxation')) &&
										<>
											{(enableCostAllocation &&  (disableUpdate ? (details && details.category && details.category === 'Utilities') : !disableUpdate)) ?
												<div style={{ left: 'calc(100% - 650px)', right: 0, bottom: 0, background: '#fff', borderTop: '1px solid var(--border-color)', position: 'fixed', height: 55, width: '100%', display: 'flex', alignItems: 'center', paddingLeft: 10, paddingRight: 10 }}>
													<div onClick={() => {

														if (btnloading) {
															return;
														}

														let costAllocation = COSTALLOCATION && COSTALLOCATION.current && COSTALLOCATION.current.getValue();

														if (costAllocation === true) {
															showToast({
																type: 'error',
																message: "Please update the cost allocation"
															})
															return;
														}

														if (costAllocation === false) return

														let costAllocationAtItems = {};
														invoices.forEach(i => {
															if (i.costAllocations) {
																costAllocationAtItems[i.id] = i.costAllocations
															}
														})

														let data = {
															costAllocation: {
																...costAllocation,
																costAllocationAtItems
															}
														}
														
														setBtnLoading(true);

														post(`/vendor/invoicing/${id}/invoicing.costAllocation.update`, data, (e, r) => {
															if (r) {
																setEnableCostAllocation(false);
																setBtnLoading(false);
																props.onReload()

															} else {
																setBtnLoading(false)
																showToast({
																	type: 'error',
																	message: e.data.message
																})
															}
														})

													}} className='btn btn-portlet-success' style={{ background: "#ffe4b3", color: '#ffa500', width: '100%', maxWidth: '620px' }}>
														{
															btnloading ?
																"Updating;.."
																:
																"Update Cost Allocation"
														}
													</div>
												</div>
												:
												<div style={{ zIndex:'10000',left: 'calc(100% - 600px)', right: 0, bottom: 0, background: '#fff', borderTop: '1px solid var(--border-color)', position: 'fixed', height: 'auto', display: 'flex', alignItems: 'center', paddingLeft: 10, paddingRight: 10 }}>
												<div style={{  width: '100%' }}>
												  <div style={{display:'flex',paddingTop:10,paddingBottom:10,gap:10}}>
													<ReadOnly>
														<div onClick={() => {
														if (btnloading) {
																return;
														}
														if(costAllocation && mandatoryCostAllocationAtTaxationApproval && !costAllocationDone) {
															showToast({
																type: 'error',
																message: "Cost Allocation is mandatory"
															})
															return;
														}
														let flag = true;
														let count = 0;
														let internalCount = 0;
														getActiveCustomFormRefs().forEach((ref) => {
															flag = false;
															ref.getKeyValue(val => {
																if (Object.keys(val).length) {
																	count++;
																}
																flag = true;
											
															});
														})
														if (!flag) {
															showToast({
																type: 'error',
																message: "Please check line item custom first"
															})
															return
														}
														if (count > 0) {
															details.invoice.items.forEach((i, index) => {
																let formValue = {};
																const formRef = CUSTOMFORM.current[index];
																if (!formRef) return;
																formRef.getKeyValue(val => {
																	formValue = { ...val }
																})
																setBtnLoading(true);
																post(`settlements/vendor/invoices/${details.invoice.id}/item.form`, { "itemId": i.id, "itemForms": { ...formValue } }, (e, r1) => {
																	if (r1) {
																		internalCount++;
																		if (internalCount === count) {
												
																			TAXATION_CATEGORY_FORM.current.getKeyValue(val => {
																				let data = {
																					forms: {
																						...val
																					}
																				}
																				setBtnLoading(true);
																				post(`/settlements/vendor/invoices/${id}/postTaxationApproval`,data, (e, r) => {
																					if (r) {
																						showToast({
																							type: 'success',
																							message: 'Invoice approved successfully'
																						})
																						props.onReload()
																						props.onClose(false)
																						setBtnLoading(false);
																					} else {
																						setBtnLoading(false);
																						handleError(e)
																					}
																				})
																			})
												
																		}
																		setBtnLoading(false);
																	} else {
																		setBtnLoading(false);
																	}
																})
															})
														}
														if (flag) {
															if (count === 0) {
																	setBtnLoading(true);
																	TAXATION_CATEGORY_FORM.current.getKeyValue(val => {
																		let data = {
																			forms: {
																				...val
																			}
																		}
																		setBtnLoading(true);
																		post(`/settlements/vendor/invoices/${id}/postTaxationApproval`,data, (e, r) => {
																			if (r) {
																				showToast({
																					type: 'success',
																					message: 'Invoice approved successfully'
																				})
																				props.onReload()
																				props.onClose(false)
																				setBtnLoading(false);
																			} else {
																				setBtnLoading(false);
																				handleError(e)
																			}
																		})
																	})
																}
												
														} else {
															showToast({
																type: 'error',
																message: "Please check line item custom first"
															})
														}

														}}
														className='btn btn-portlet'
														 style={{ width: '100%', maxWidth: '315px' }}
														>
															{
															btnloading ?
																"Loading..."
																:
																"Approve"
														}
														</div>
													</ReadOnly>
															<ReadOnly>
																<div onClick={() => {
																	setDecline(details.invoice.id)
																}} className='btn btn-portlet-success' style={{ background: "#ffdad4", color: '#ba1b1b', width: '100%', maxWidth: '315px' }}>
																	Decline
																</div>
															</ReadOnly>
															{!details.invoiceRevertBack && (details && details.type !== 'utility') && <ReadOnly>
																<div onClick={() => {
																	setRevertBack(details.invoice.id)
																}} className='btn btn-portlet-black' style={{ background: "black", color: 'white', width: '100%', maxWidth: '315px' }}>
																	Send Back
																</div>
													</ReadOnly>}
												</div>
												</div>
												</div>
											}
											
										</>
									}

									{
										(status === 'DRAFT' && isOwnerAdmin())?
										<div style={{ zIndex:'10000',left: 'calc(100% - 600px)', right: 0, bottom: 0, background: '#fff', borderTop: '1px solid var(--border-color)', position: 'fixed', height: 'auto', display: 'flex', alignItems: 'center', paddingLeft: 10, paddingRight: 10 }}>
											<div style={{  width: '100%' }}>
												<div style={{display:'flex',paddingTop:10,paddingBottom:10,gap:10}}>
													<ReadOnly>
														{
															btnloading ?
															<div style={{
																height:48,
																minWidth:'250px',
																display:'flex',
																justifyContent:'center',
																alignItems:'center',
																background:'var(--primary-color)',
																marginTop:20,
																borderRadius:4
															}}>
																<StateButton />
															</div>
															: 
															<div onClick={()=>{
																setBtnLoading(true);
																post(`/vendor/invoicing/${id}/moveNext`, {}, (e,r)=>{
																	if(r){
																		showToast({
																			type: 'success',
																			message: 'Invoice moved successfully'
																		})
																		props.onReload()
																		setBtnLoading(false);
																	}
																	else if(e){
																		handleError(e);
																		setBtnLoading(false);
																	}
																})
															}} className='btn btn-portlet-black' style={{ background: "black", color: 'white', width: '100%',minWidth:'250px'}}>
																Move Next
															</div>
														}
													</ReadOnly>
													{(showDecline && (showDecline === "all_stages")) && <ReadOnly>
														<div onClick={() => {
															setDecline(details.invoice.id)
														}} className='btn btn-portlet-success' style={{ background: "#ffdad4", color: '#ba1b1b', width: '100%', maxWidth: '315px'}}>
															Decline
														</div>
													</ReadOnly>} 
												</div>
											</div>
										</div> 
										: (status === 'PENDING' || status === 'DRAFT' || status === 'POHOLD') ?
											<div style={{ zIndex:'10000',left: 'calc(100% - 600px)', right: 0, bottom: 0, background: '#fff', borderTop: '1px solid var(--border-color)', position: 'fixed', height: 'auto', display: 'flex', alignItems: 'center', paddingLeft: 10, paddingRight: 10 }}>
												<div style={{  width: '100%' }}>
													<div style={{display:'flex',paddingTop:10,paddingBottom:10,gap:10}}>
														{(showDecline && (showDecline === "all_stages")) && <ReadOnly>
															<div onClick={() => {
																setDecline(details.invoice.id)
															}} className='btn btn-portlet-success' style={{ background: "#ffdad4", color: '#ba1b1b', width: '100%', maxWidth: '315px'}}>
																Decline
															</div>
														</ReadOnly>} 
													</div>
												</div>
											</div>
										: (status === 'APPROVAL') ?
											(enableCostAllocation &&  (disableUpdate ? (details && details.category && details.category === 'Utilities' ) : !disableUpdate)) ?
												<div style={{ left: 'calc(100% - 650px)', right: 0, bottom: 0, background: '#fff', borderTop: '1px solid var(--border-color)', position: 'fixed', height: 55, width: '100%', display: 'flex', alignItems: 'center', paddingLeft: 10, paddingRight: 10 }}>
													<div onClick={() => {

														if (btnloading) {
															return;
														}

														let costAllocation = COSTALLOCATION && COSTALLOCATION.current && COSTALLOCATION.current.getValue();

														if (costAllocation === true) {
															showToast({
																type: 'error',
																message: "Please update the cost allocation"
															})
															return;
														}

														if(costAllocation === false) return

														let costAllocationAtItems = {};
														invoices.forEach(i => {
															if (i.costAllocations) {
																costAllocationAtItems[i.id] = i.costAllocations
															}
														})

														let data = {
															costAllocation: {
																...costAllocation,
																costAllocationAtItems
															}
														}

														setBtnLoading(true);

														post(`/vendor/invoicing/${id}/invoicing.costAllocation.update`, data, (e, r) => {
															if (r) {
																setEnableCostAllocation(false);
																setBtnLoading(false);
																props.onReload()

															} else {
																setBtnLoading(false)
																showToast({
																	type: 'error',
																	message: e.data.message
																})
															}
														})

													}} className='btn btn-portlet-success' style={{ background: "#ffe4b3", color: '#ffa500', width: '100%', maxWidth: '620px' }}>
														{
															btnloading ?
																"Updating;.."
																:
																"Update Cost Allocation"
														}
													</div>
												</div>
												:
												<div style={{ zIndex:'10000',left: 'calc(100% - 600px)', right: 0, bottom: 0, background: '#fff', borderTop: '1px solid var(--border-color)', position: 'fixed', height: 'auto', display: 'flex', alignItems: 'center', paddingLeft: 10, paddingRight: 10 }}>
												
													{
														paymentAdviceCopy ?
															<div />
															:

															<div style={{  width: '100%' }}>
																<div style={{display:'flex',paddingTop:10,paddingBottom:10,gap:10}}>
																	<ReadOnly>
																		<div onClick={() => {
																			if (btnloading) {
																				return;
																			}
																			if (details.type === "utility") {
																				setBtnLoading(true);
																				let id = (details && details.invoice && details.invoice.id) ? details.invoice.id : "";
																				post(`/settlements/vendor/utility/${id}/approve`, {}, (e, r) => {
																					if (r) {
																						props.onReload();
																						showToast({
																							type: 'success',
																							message: 'Invoice approved successfully'
																						})
																						setBtnLoading(false);
																						return;
																					}
																					else if (e) {
																						handleError(e);
																						setBtnLoading(false);
																						return;
																					}
																				})
																			} else {
																				if (hsnMandatorySingleLineInvoice) {
																					let HSNExist = true;
																					details.invoice.items.forEach(el => HSNExist = HSNExist && el.hsn);
																					if (!HSNExist) {
																						showToast({
																							type: 'error',
																							message: "Please add HSN to all the line items."
																						})
																						return
																					}
																				}
																				if (tdsAtLineItem && tdsSlabMandatory) {
																					let TDSExist = true;
																					details.invoice.items.forEach(el => TDSExist = TDSExist && el.tdsCode);
																					if (!TDSExist) {
																						showToast({
																							type: 'error',
																							message: "Please add TDS to all the line items."
																						})
																						return
																					}
																				}
																				if (activeRooms.length > 0) {
																					showToast({
																						type: 'error',
																						message: "Unable to approve invoice: A room is currently open. Please ensure all rooms are closed before proceeding."
																					})
																					return
																				}
																				if (btnloading) {
																					return
																				} else if (!costAllocationDone && mandatoryCostAllocation && costAllocation) {
																					showToast({
																						type: 'error',
																						message: "CostAllocation is mandatory"
																					})
																					return;
																				}  else {
																				 	approveHandler()
																				}
																			}
																		}} className='btn btn-portlet-success' style={{ background: "#E4EFE7", color: '#198754', width: '100%', maxWidth: '315px' }}>
																			{
																				btnloading ?
																					"Loading..."
																					:
																					"Approve"
																			}
																		</div>
																	</ReadOnly>
																	{partialPaymentPriorFinanceApproval && details.status === 'APPROVAL' && <ReadOnly>
																			<div onClick={() => {
																				setPartialPaymentModal(true)
																			}} className='btn btn-portlet-success' style={{ background: "#E4EFE7", color: '#198754', width: '100%', maxWidth: '315px' }}>
																				Partial Pay
																			</div>
																	</ReadOnly>}
																	{VENDOR.gstReturnStatus === "DEFAULTER" && <ReadOnly>
																		<div onClick={() => {
																			setWithholdGstModal(true)
																		}} className='btn btn-portlet-black' style={{ background: "black", color: 'white', width: '100%', maxWidth: '315px'}}>
																			Withhold GST
																		</div>
																	</ReadOnly>}
																	{(showDecline && (showDecline === "approval" || showDecline === "all_stages")) && <ReadOnly>
																		<div onClick={() => {
																			setDecline(details.invoice.id)
																		}} className='btn btn-portlet-success' style={{ background: "#ffdad4", color: '#ba1b1b', width: '100%', maxWidth: '315px'}}>
																			Decline
																		</div>
																	</ReadOnly>} 
																	{!details.invoiceRevertBack && (details && details.type !== 'utility') && <ReadOnly>
																		<div onClick={() => {
																			setRevertBack(details.invoice.id)
																		}} className='btn btn-portlet-black' style={{ background: "black", color: 'white', width: '100%', maxWidth: '315px'}}>
																			Send Back
																		</div>
																	</ReadOnly>}
																</div>
																{/* immediate  wallet recharge request */}
																{walletRechargeRequest &&
																	details &&
																	(() => {
																		const isUtilities = details.category === 'Utilities';
																		const isRental =
																			details.category === 'ZRNT - Serv Proc-Rent Dom' &&
																			multipleDepositTypePerContractItem &&
																		   (details.invoice.amount - (details.taxInformation.amountAdjustedAgainstDeposit||0) > 0);
																		const noRechargeTag = (details.tags && !details.tags['rechargeRequestId']);

																		return (isUtilities || isRental) && noRechargeTag && !adjustedInvoice;
																	})() && (
																		<ReadOnly>
																			<div style={{ paddingTop: 10, paddingBottom: 10 }}>
																				<WalletRechargeRequest
																					invoiceId={details && details.invoice && details.invoice.counterId}
																					details={details}
																					adjuctedAmout={details.taxInformation.amountAdjustedAgainstDeposit || 0}
																					multipleDepositTypePerContractItem={multipleDepositTypePerContractItem}
																					dueOn={details.dueOn}
																					bulkPeWallet={false}
																					rental={details.category === 'ZRNT - Serv Proc-Rent Dom'}
																					customAcc={
																						(details.category === 'ZRNT - Serv Proc-Rent Dom' && (tenant === 'bajajelec')) ? 'bajajelec'
																						: (details.category === 'ZRNT - Serv Proc-Rent Dom' && (tenant === 'BAJAJELECT')) ? 'BAJAJ ELECTRICALS LIMITED - Rental'
																						: (details.tags['contract.id'] && (details.category === 'Utilities') && (tenant === 'bajajelec')) ? 'bajajelec-utitlity'
																						: (!details.tags['contract.id'] && (details.category === 'Utilities') && (tenant === 'BAJAJELECT')) ? 'Eka Virtual Account'
																						: (details.tags['contract.id'] && (details.category === 'Utilities') && (tenant === 'BAJAJELECT')) ? 'BAJAJ ELECTRICALS LIMITED - utility'
																						: undefined
																					}
																					reload={() => {
																						props.onReload();
																						props.reloadInvoice();
																					}}
																				/>
																			</div>
																		</ReadOnly>
																	)}
															</div>
													}

												</div>
											: null
									}
									{
										status === "GST_WITHHOLD" && VENDOR.gstReturnStatus !== "DEFAULTER" &&
										<div style={{ left: 'calc(100% - 650px)', right: 0, bottom: 0, background: '#fff', borderTop: '1px solid var(--border-color)', position: 'fixed', height: 55, width: '100%', display: 'flex', alignItems: 'center', paddingLeft: 10, paddingRight: 10 }}>
											<div onClick={() => {
												if (btnloading) {
													return;
												}
												setBtnLoading(true);
												post(`/settlements/vendor/invoices/${id}/onHoldPayment/markComplete`, {}, (e, r) => {
													if (r) {
														setBtnLoading(false);
														props.onReload()
													} else {
														setBtnLoading(false)
														showToast({
															type: 'error',
															message: e.data.message
														})
													}
												})
											}} className='btn btn-portlet-success' style={{ background: "#ffe4b3", color: '#ffa500', width: '100%', maxWidth: '620px' }}>
												{
													btnloading ?
														"Updating;.."
														:
														"Mark Complete"
												}
											</div>
										</div>
									}
									{ 
									 checkTypeAsAdmin(details && details.owner,status)  ? 
								      <>
									   {/* <div onClick={()=>{
								 	   	setWithdraw(true)
									}} style={{
										background: '#FF532E',
										color: '#fff',
										textAlign: 'center',
										fontSize: 15,
										padding: 15,
										marginTop: 25,
										fontWeight: 600,
										cursor: 'pointer',
										borderRadius:4
									}}>Withdraw Invoice</div> */}
									  </>
									: null
									}
								</div> : <></>
							}

							{getTab === 2 ?
								<>
									<div id="Invoice_Insight" className='FadeRight-Effect'>
										{
											irnData ? <IrnDetails data={irnData} /> : null
										}
										<div
											style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Insights
										</div>
										{
											(tags2 && Object.keys(tags2).length>0)? <>
												{Object.entries(tags2).map(renderTags)}
											</>:null
										}
										{
											(details && details.vendor && details.vendor.customTags && details.vendor.customTags.pan_aadhaar_linked && details.vendor.customTags.pan_aadhaar_linked === "true") ?
												<FloatInputButton
													title={"Pan Status"}
													type={'text'}
													placeholder={"Operative"}
													disabled
												/> : (details && details.vendor && details.vendor.customTags && details.vendor.customTags.pan_aadhaar_linked && details.vendor.customTags.pan_aadhaar_linked === "false") ?
													<FloatInputButton
														title={"Pan Status"}
														type={'text'}
														placeholder={"Inoperative"}
														disabled
												/> : null
										}
										{
											tags1? <>
												{Object.entries(tags1).map(renderTags)}
												{['APPROVAL','TAXATION_APPROVAL'].includes(details.status) &&
													<>
														{Object.entries(customTags)
															.filter(([key]) => key === 'cost_center' || key === 'profit_center')
															.map(([key, value]) => (
																<FloatInputButton
																	title={key}
																	type={'text'}
																	placeholder={value}
																	disabled
																/>
														))}
													</>
												}
											</> : <></>
										}

										{
											details.invoice.items.filter(i => i.data.length > 0).map(mapLineItemTag)
										}
										<div
											style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>View
										</div>
										{
											details.views && details.views.map(mapView)
										}
									</div>
									<div style={{display: 'flex'}}>
										<div style={{width: '33%'}}><FloatInputButton onSubmit={(val) => {
											updateInvoice('sgst', val)
										}} title='SGST / UTGST '
											placeholder={details.taxInformation.sgst?details.taxInformation.sgst.toFixed(3):details.taxInformation.sgst}
											disabled={details.status !== 'APPROVAL' || disableUpdate}
											/>
										</div>
										<div style={{width: '33%', paddingLeft: '10px'}}><FloatInputButton
											onSubmit={(val) => {
												updateInvoice('igst', val)
											}} title='IGST ' placeholder={details.taxInformation.igst?details.taxInformation.igst.toFixed(2):details.taxInformation.igst} disabled={details.status !== 'APPROVAL' || disableUpdate}/></div>
										<div style={{width: '33%', paddingLeft: '10px'}}><FloatInputButton
											onSubmit={(val) => {
												updateInvoice('cgst', val)
											}} title='CGST' placeholder={details.taxInformation.cgst ? details.taxInformation.cgst.toFixed(3) : details.taxInformation.cgst} disabled={details.status !== 'APPROVAL' || disableUpdate}/></div>
									</div>
									<>
									{details && details.taxInformation && Array.isArray(details.taxInformation.additionalCharges) && details.taxInformation.additionalCharges.length>0 && details.taxInformation.additionalCharges[0] && Object.keys(details.taxInformation.additionalCharges[0].data || {}).length>0 && (
									    <>
										<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Total Additional Tax Amount</div>
										<div style={{ marginTop: "20px", width: "100%" }}>
										<table
											style={{
											borderCollapse: "collapse",
											width: "100%",
											border: "1px solid #ccc",
											}}
										>
											<thead>
											<tr>
												<th style={{ width: "50px", border: "1px solid #ccc", padding: "8px", textAlign: "left", backgroundColor: "#f5f5f5" }}>S.No</th>
												<th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left", backgroundColor: "#f5f5f5" }}>SGST</th>
												<th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left", backgroundColor: "#f5f5f5" }}>IGST</th>
												<th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left", backgroundColor: "#f5f5f5" }}>CGST</th>
											</tr>
											</thead>
											<tbody>
											{details.taxInformation.additionalCharges.map((item, index) => (
												<tr key={index}>
												<td style={{ width: "50px", border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>{index + 1}</td>
												<td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>{item && item.data && item.data.sgst ? item.data.sgst : '-'}</td>
												<td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>{item && item.data && item.data.igst ? item.data.igst : '-'}</td>
												<td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>{item && item.data && item.data.cgst ? item.data.cgst : '-'}</td>
												</tr>
											))}
											</tbody>
										</table>
										</div>
										</>
									)}
									</>
									<div style={{border:'1px solid var(--border-color)',padding:12,borderRadius:12,marginTop:20,paddingTop:10}}>
										<div style={{'display':'flex','justifyContent':'space-between'}}>
											<div onClick={() => {setShow((!show))}} style={{fontSize: '14px', fontWeight: 'bold', cursor:'pointer'}}>Custom Tags</div>
											<div style={{'border':'1px solid black', 'borderRadius':'100%', width:'18px',height:'18px','display':'flex','justifyContent':'center', 'alignItems':'center',cursor:'pointer'}} onClick={() => {setShow((!show))}}>
												<img style={{width:12,transform:!show?'rotate(0deg)':'rotate(180deg)'}} src={require('../../../fCommon/ViewCreditNote/India/down.png')} alt="down"/>
											</div> 
										</div>
										{(show)?<div style={{marginLeft:'1rem'}}>
											<CustomTags title={"Vendor Custom Tags"} data={(details && details.vendor && details.vendor.customTags)?details.vendor.customTags:{}}/>
											<CustomTags title={"Address Custom Tags"} data={(details && details.address && details.address.customTags)?details.address.customTags:{}}/>
											<CustomTags title={"Deliver To Custom Tags"} data={(details && details.deliverTo && details.deliverTo.customTags)?details.deliverTo.customTags:{}}/>
											<CustomTags title={"Owner Custom Tags"} data={(details && details.ownerCustomTags)?details.ownerCustomTags:{}}/>
										</div>:null}
									</div>
								</> : <></>
							}
							{getTab === 3 ?
								<div id="Invoice_Timeline" className='FadeRight-Effect'>
									<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Timeline
									</div>
									<Track stages={
										[...details.timelines.map((log, index) => {
											

											let DESC = <div><b>{log.name}</b><b>{log.owner && log.owner.ownerType === "ADMIN" ? " (Admin)" : ""}</b><br />
												{log.position && typeof log.position === 'string'  ? 
													<span>{log.position.includes('@') ? log.position.split('@')[0] : log.position}</span>:null
												}
												<div style={{ marginTop: '5px' }}>Type: {log.type}</div>
												{log.status && 
												<div style={{ marginTop: '5px' }}>Status: {log.status}</div>
												}
												{
													(log && log.status==="HOLD")?checkForHoldRemarks(index):null
												}
												{
													log.name==='Payment Done' && parsed && parsed.paymentDone && parsed.paymentDone.length ? 
													<div style={{ margin: '10px 0' }} >					
														<div style={{ marginTop: '1px' }}>Payment Done By :  {parsed.paymentDone[0].name} ,</div>
														<div style={{ marginTop: '1px' }}>Email : {parsed.paymentDone[0].email} ,</div>
														<div style={{ marginTop: '1px' }}>Time : {Moment(parsed.paymentDone[0].actionTime).format("hh:mm a DD MMM YY")}</div>
													</div>
													: null
												}
												{ 
													(log.status==="REVERTED" && log.revertedTo)?<div style={{ marginTop: '5px' }}>Reverted to : {log.revertedTo}</div>:null
												}
												{((log.status==="REVERTED" || log.status==="DELEGATED" )&& log.revertedRemarks)? <div style={{marginTop: '5px'}}>Revert remarks: {log.revertedRemarks}</div> : null}
												<div style={{ marginTop: '5px' }}>
													{log.actionTime && (log.status !== 'PENDING' && excludeStatus.includes(log.status)) ?
														`${_.capitalize(log.status)} on: ${Moment(log.actionTime).format(" hh:mm a DD MMM YY")}`
														: log.actionTime && log.status !== 'PENDING' && log.type !== 'start' && index ?
														<>
														<div>Sent on : {`${moment(details.timelines[index-1].actionTime).format("hh:mm a DD MMM YY")}`}</div>
														{!['APPROVAL','Pending','SETTLEMENT_REQUEST'].includes(log.type) && 
													  	 <div>Approved on: {`${moment(log.actionTime).format(" hh:mm a DD MMM YY")}`}</div>
														}
														</>
															:
															`Sent on: ${Moment(log.time).format("hh:mm a DD MMM YY")}`
													}
												</div>
												{
													<>
														{(log.emulatedByName && log.emulatedByName !== "-") ? <div style={{ marginTop: '5px' }}>Ea-User: {log.emulatedByName}</div>:null}
														{(log.emulatedByCode && log.emulatedByCode !=="-") ? <div style={{ marginTop: '5px' }}>Ea-UserId: {log.emulatedByCode}</div>:null}
													</>
												}
											</div>
											return (
												{
													title: log.email,
													desc: DESC,
													cancelled: log.status === 'CANCELLED' || log.status === 'DECLINED' || (log.type && (log.type === 'withdrawn')),
													status: log.type === 'start' || log.type === 'scanner-end' || log.status === 'APPROVED' || (log.type === 'scanner-start' && details.timelines.length > (index + 1)) ? true : log.status ? timelineLogStatus.includes(log.status): (log.name === 'Finance Action' || log.email === 'Finance Action') || log.type === 'Completed'|| log.name === 'COMPLETED' ||  (log.email && log.email.includes('Taxation Approved'))? true : false
												})
										})]
									} />
								</div> : <></>
							}
							{getTab === 12 ?
								<div id="Invoice_Logs" className='FadeRight-Effect'>
									<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Logs</div>
									<div style={{"marginBottom":"1rem"}}>
										{
											details.invoice.logs.map((item, index)=>{
												return(
													<div key={`comments-${index}`}><span style={{color: '#666', marginRight: '5px'}}>{Moment(item.time).format(" hh:mm a DD MMM YY")}</span>: {item.log} - <span>by : {item.owner.ownerName}</span>
													<div>Remarks : {item.remarks}</div>
													</div>
												)
											})
										}
									</div>
								</div> : <></>
							}
							{
								getTab === 4 ?
									<div id="Settlements" className="FadeRight-Effect">
										{
											Settlements ?
												<div style={{ marginTop: 30 }}>
													<KeyValue title="LedgerId" value={Settlements.ledgerId} />
													<KeyValue title="Created At" value={Moment(Settlements.createdAt).format(settlementFormate)} />
													<KeyValue title="Currency" value={Settlements.currency} />
													{Settlements && Settlements.attrs && Settlements.attrs.holdRemark ? <KeyValue title="Settlement Hold Remarks" value={Settlements.attrs.holdRemark} /> : null}
													{
														Settlements && Settlements.attrs && Settlements.attrs.payment_date ?
														<KeyValue title="Payment date" value={Settlements.attrs.payment_date} />
														:null
													}
													{Settlements.attrs && Settlements.attrs.key && Settlements.attrs.key === "payment_date" && (
														<KeyValue title="Payment Date" value={Settlements.attrs.value && moment(Settlements.attrs.value).format('DD-MM-YYYY')} />
													)}
													{Settlements.attrs && Settlements.attrs.utr && (
														<FloatInputButton
															disabled={false}
															style={{ width: '100%' }}
															title={"Utr"}
															placeholder={Settlements.attrs.utr}
															onSubmit={onAddUtr}
														/>
													)}
												</div>
												: null
										}
										{
											Settlements ?
												Settlements.settlements && Settlements.settlements.length ?
													<div className='FadeRight-Effect'>
														<div style={{ marginTop: 30 }}><span style={{ color: '#666', marginRight: '3px' }}>Ledger ID: </span>{Settlements.ledgerId}</div>
														<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Amount: </span>{Settlements.currency} {Settlements.amount}</div>
														<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Created On: </span>{moment(Settlements.createdAt).format('HH:MM a DD-MM-YYYY')}</div>
														<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Remarks: </span>{Settlements.attrs.remarks}</div>
														<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Virtual Payout: </span>{Settlements.attrs['virtual.payout']}</div>
														<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Reference: </span>{Settlements.attrs.reference}</div>

														<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px', marginBottom: '20px' }}>Settlements</div>
														{
															Settlements.settlements && Settlements.settlements.length ?
																 Settlements.settlements.map((item, index) => {
																	
																	return (
																		<div style={{ padding: '10px 20px', border: '1px solid var(--border-color)', position: 'relative', borderRadius: '6px', marginTop: '15px' }}>
																			<div key={`info-${index}`} style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Created On: </span>{moment(item.createdAt).format('HH:MM a DD-MM-YYYY')}</div>
																			<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Amount: </span>{item.currency} {item.amount}</div>
																			<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Ledger ID: </span>{item.ledgerId}</div>
																			<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Type: </span>{item.type}</div>
																			{
																				item.type === 'INVOICES' || item.type === 'POADVANCE'|| item.type === 'VENDORADVANCE' ?
																					<>
																						<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>TDS Amount: </span>{item.tdsAmount||0}</div>
																						<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Comsumed Amount: </span>{item.paidAmount||0}</div>
																					</>
																					: <></>
																			}
																			{item.reference && (
																				<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Reference: </span>{item.reference||'-'}</div>						
																			)}
																			<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px' }}>Transferred: </span>{item.transferred ? 'Yes' : 'No'}</div>
																			{
																				item.utr &&
																				<div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>UTR: </span>{item.utr}</div>
																			}
																			{
																				item.attrs && item.attrs['payment_date'] &&
																				<div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Payment Date: </span>{item.attrs['payment_date']}</div>
																			}
																			{
																				item.attrs && item.attrs['clearing_document'] &&
																				<div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Clearing Document No: </span>{item.attrs['clearing_document']}</div>
																			}
																			<div style={{ fontWeight:'bold', position: 'absolute', cursor: 'pointer', right: 10, top: 10, color: 'var(--red-color)', display:'flex', gap:'5px' }}>
																				{(details && ['APPROVAL','TAXATION_APPROVAL'].includes(details.status) && !(tenant === 'ANRCK' || tenant === 'ANAROCK'))?<div onClick={() => { setUntag(item) }}>Untag</div>:null}
																				{item.type === 'PARTIAL' && !item.transferred ?
																					<div onClick={() => { setRecallPartial(item) }}>Recall</div>
																					: null
																				}
																			</div>
																			{
																				item.attrs && item.attrs.clearing_document && item.attrs.document_number &&
																				<div style={{ marginTop: '15px' }}>
																					<div 
																						style={{ 
																							cursor: 'pointer', 
																							color: '#4DA6FF', 
																							fontSize: '14px', 
																							fontWeight: 600,
																							display: 'flex',
																							alignItems: 'center',
																							gap: '5px'
																						}}
																						onClick={() => {
																							const currentExpanded = expandedIntegrationData === `${item.ledgerId}-${index}`;
																							setExpandedIntegrationData(currentExpanded ? null : `${item.ledgerId}-${index}`);
																						}}
																					>
																						<span style={{ 
																							display: 'inline-block',
																							transition: 'transform 0.2s',
																							transform: expandedIntegrationData === `${item.ledgerId}-${index}` ? 'rotate(90deg)' : 'rotate(0deg)'
																						}}>▶</span>
																						<span>Integration Data</span>
																					</div>
																					{expandedIntegrationData === `${item.ledgerId}-${index}` && (
																						<div style={{ 
																							marginTop: '10px', 
																							padding: '15px', 
																							backgroundColor: '#f8f9fa', 
																							borderRadius: '6px',
																							border: '1px solid var(--border-color)'
																						}}>
																							{item.attrs.adjusted_amount && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Adjusted Amount: </span>{item.attrs.adjusted_amount}</div>
																							)}
																							{item.attrs.clearing_date && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Clearing Date: </span>{item.attrs.clearing_date}</div>
																							)}
																							{item.attrs.clearing_document && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Clearing Document: </span>{item.attrs.clearing_document}</div>
																							)}
																							{item.attrs.document_date && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Document Date: </span>{item.attrs.document_date}</div>
																							)}
																							{item.attrs.document_number && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Document Number: </span>{item.attrs.document_number}</div>
																							)}
																							{item.attrs.document_type && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Document Type: </span>{item.attrs.document_type}</div>
																							)}
																							{item.attrs.document_year && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Document Year: </span>{item.attrs.document_year}</div>
																							)}
																							{item.attrs.payment_date && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Payment Date: </span>{item.attrs.payment_date}</div>
																							)}
																							{item.attrs.payment_document && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Payment Document: </span>{item.attrs.payment_document}</div>
																							)}
																							{item.attrs.payment_reference && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Payment Reference: </span>{item.attrs.payment_reference}</div>
																							)}
																							{item.attrs.payment_voucher && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Payment Voucher: </span>{item.attrs.payment_voucher}</div>
																							)}
																							{item.attrs.payment_amount && (
																								<div style={{ marginTop: '5px' }}><span style={{ color: '#666', marginRight: '3px', fontWeight: 600 }}>Payment Amount: </span>{item.attrs.payment_amount}</div>
																							)}
																						</div>
																					)}
																				</div>
																			}
																		</div>
																	)
																})
																: <div style={{ padding: '20px', border: '1px solid var(--border-color)', borderRadius: '6px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>No Information available</div>
														}
													</div>
													: <div style={{ padding: '20px', border: '1px solid var(--border-color)', marginTop: 20, borderRadius: '6px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>No Information available</div>
												: <Spinner />
										}
										{
											Settlements  ?
												<div className='FadeRight-Effect'>
													{
														!Settlements.settled ?
															<>
																<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Partial Payment</div>
																<span style={{
																	fontSize: 14,
																	fontWeight: 600,
																	cursor: 'pointer',
																	color: 'var(--primary-color)',
																}} onClick={() => {
																	setPartial(true)
																}}>+ Add Partial Payment</span>
															</>
															:
															null

													}
												</div>
												: null
										}
										{ (approvalStatus(details.status) || ((details.status === 'COMPLETED' && Settlements && !Settlements.settled))) && allIndependentCN && allIndependentCN.length > 0 &&
											<>
												<div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Sync Credit Note</div>
												{
													allIndependentCN.map((item, index) => {
														return (
															<div key={index} style={{ backgroundColor: '#e4e1ec', display: 'flex', justifyContent: 'space-between', cursor: 'pointer', padding: '15px', marginBottom: 10, borderRadius: 8, marginTop: '20px' }}>
																<div >
																	<p style={{ fontSize: 14, fontWeight: 'bold' }}>{item.creditNoteId}</p>
																	<p style={{ fontSize: 12 }}>Amount :{item.currency} {numberWithCommas(item.amount)}</p>
																	<p style={{ fontSize: 12 }}>Created At : {Moment(item.createdAt).format('DD-MM-YYYY')}</p>
																	<p onClick={()=>syncCreditNote(item)} style={{background: 'var(--primary-color)', cursor: 'pointer', color: 'rgb(255, 255, 255)', padding: '5px 5px', borderRadius: '4px',width:'100px',textAlign:'center',marginTop:'12px'}}>Sync</p>
																</div>
																<div>
																	<p style={{ background: 'rgb(13, 110, 253)', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 11, padding: '4px 10px', color: "#fff", borderRadius: 4 }}>{item.status}</p>
																</div>
															</div>

														)
													})
												}
											</>
										}
										{
											Settlements && Settlements.advances && Settlements.advances.length ?
												<>
													<div style={{ fontSize: '14px', marginBottom: 20, fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>Select Advance to settled this invoice</div>
													<NormalTable
														headers={[
															{
																key: "code",
																name: "Details",
																weight: 3,
															},
															{
																key: "amount",
																name: "Amount",
																weight: 2,
															},

														]}
														data={advanceSettlements.filter(val => val.transferred).filter(val => ['ANAROCK','ANRCK'].includes(tenant) && details.entityId && entityHierarchy ? (details.entityId === val.entity):true)}
														mapItem={(item, index) => {
															let active = item.ledgerId === advance;
															return (
																<div key={index} className="border-bottom fintrip-department-item table-item">
																	<div className="linear-layout horizontal">
																		<div style={{ flex: 3 }}>
																			<div style={{
																				display: 'flex',
																				alignItems: 'center'
																			}}>
																				{approvalStatus(details.status) &&
																				<div onClick={() => {
																					if(advance && item && item.ledgerId && advance===item.ledgerId){
																						setAdvance(false)
																					}
																					else{
																						setAdvance(item.ledgerId);
																					}
																				}}
																				style={{ height: 15, cursor: 'pointer', width: 15, border: '1px solid var(--border-color)', ...active ? { background: 'var(--success-color)', borderColor: 'var(--success-color)' } : { borderColor: 'var(--border-color)' } }}
																				 />
																				}
																				<div style={{ marginLeft: 10 }}>
																					<p onClick={(e) => {
																						e.stopPropagation();
																						setLedger(item.ledgerId);
																					}} className="top" style={{ fontSize: 14, cursor: 'pointer' }}>{item.ledgerId}</p>
																					{item.vendorAdvanceId ? <p style={{ fontSize: 11, marginTop: 5 }}>Vendor Advance ID : {item.vendorAdvance}</p> : null}
																					<p style={{ fontSize: 11, marginTop: 2 }}>Type : {item.type}</p>
																					{(item && item.taggedByEmployee) ? <p style={{ marginTop: 2, fontWeight: 'bold', fontSize: '14px' }}>Tagged By Employee</p> : null}
																					{(item && (item.ldcDescription || item.ldcRate || item.tdsAmount || item.tdsCode || item.tdsDescription || item.tdsMasterRate)) && (
																						<div style={{ marginTop: 8 }}>
																							<div 
																								onClick={() => {
																									const currentExpanded = expandedTds === item.ledgerId;
																									setExpandedTds(currentExpanded ? null : item.ledgerId);
																								}}
																								style={{ 
																									display: 'flex', 
																									alignItems: 'center', 
																									cursor: 'pointer',
																									fontSize: 11,
																									color: '#666'
																								}}
																							>
																								<span style={{ 
																									marginRight: 5,
																									transform: expandedTds === item.ledgerId ? 'rotate(90deg)' : 'rotate(0deg)',
																									transition: 'transform 0.2s'
																								}}>▶</span>
																								<span>TDS</span>
																							</div>
																							{expandedTds === item.ledgerId && (
																								<div style={{ 
																									marginTop: 5, 
																									padding: 8, 
																									border: '1px solid #e0e0e0', 
																									borderRadius: 4, 
																									backgroundColor: '#f9f9f9' 
																								}}>
																									{item && item.ldcDescription && <p style={{ fontSize: 11, margin: '2px 0' }}>LDC : {item.ldcDescription}</p>}
																									{item && item.ldcDescription && <p style={{ fontSize: 11, margin: '2px 0' }}>LDC Rate : {item.ldcRate||0}</p>}
																									{item && item.tdsAmount && <p style={{ fontSize: 11, margin: '2px 0' }}>TDS Amount : {item.tdsAmount}</p>}
																									{item && item.tdsCode && <p style={{ fontSize: 11, margin: '2px 0' }}>TDS Code : {item.tdsCode}</p>}
																									{item && item.tdsDescription && <p style={{ fontSize: 11, margin: '2px 0' }}>TDS Description : {item.tdsDescription}</p>}
																									{item && item.tdsMasterRate && <p style={{ fontSize: 11, margin: '2px 0' }}>TDS Master Rate : {item.tdsMasterRate}</p>}
																									{item && item.ldcRate && item.ldcRate>0 && <p style={{ fontSize: 11, margin: '2px 0' }}>LDC Rate : {item.ldcRate}</p>}
																								</div>
																							)}
																						</div>
																					)}
																				</div>
																				
																			</div>
																		</div>
																		<div style={{ flex: 2 }}>
																			<div>Total: {item.currency} {(item && item.amount)?item.amount.toFixed(2):""}</div>
																			{(item && item.paidAmount) ? <div>Paid: {item.currency} {(item && item.paidAmount)?item.paidAmount.toFixed(2):""}</div> : null}
																		</div>
																	</div>
																</div>
															)
														}}
													/>
													{advance ?
														<p style={{
															color: 'var(--white-color)',
															fontSize: 14,
															background: 'var(--primary-color)',
															padding: "8px 20px",
															borderRadius: 2,
															cursor: 'pointer',
															width: tdsAtLineItemAutomation?300:150,
															textAlign: 'center',
															marginTop: 20
														}} onClick={() => {
															if(tdsAtLineItemAutomation){
																post(`settlements/settlements/${advance}/invoice/${id}/tagItem`, {}, (e, r) => {
																	if (r) {
																		props.onReload();
																		fetchSettlements(id);
																		showToast({
																			type: 'success',
																			message: "Advance settled successfully against invoice"
																		})
																	} else {
																		showToast({
																			type: 'error',
																			message: e.data.message
																		})
																	}
																})
															}
															else{
																post(`settlements/settlements/${advance}/invoice/${id}/tagV2`, {}, (e, r) => {
																	if (r) {
																		props.onReload();
																		fetchSettlements(id);
																		showToast({
																			type: 'success',
																			message: "Advance settled successfully against invoice"
																		})
																	} else {
																		showToast({
																			type: 'error',
																			message: e.data.message
																		})
																	}
																})
															}
														}}>{tdsAtLineItemAutomation?"Settle Invoice (Line Item)":"Settle Invoice" }</p>
														: null
													}
												</>
												: null
										}

										{
											details.status === 'COMPLETED' && Settlements && !Settlements.settled?
											(NINJA.includes(tenant) ? null : ((integrationData && _.size(integrationData) > 0 && integrationData['postingSynced']) && (tenant !== 'DTDC' || !isSuper))) ? null:
											<div style={{ marginTop: 10 }}>
													
													<p style={{
														color: 'var(--white-color)',
														fontSize: 14,
														background: 'var(--red-color)',
														padding: "5px 12px",
														borderRadius: 4,
														cursor: 'pointer',
														position: 'absolute',
														right: 100,
														top: 30
													}} onClick={() => { setRecall(true); }}>
														Recall Invoice
													</p>
												</div>
												:
												null
										}


									</div> :
									null
							}
							{getTab ===  16 &&
								<div className='FadeRight-Effect'>
									<PartialSettlements invoiceId={id} setRecallPartial={setRecallPartial} />
								</div>
							}
							{
								getTab === 5 ?
									<div id="Po" className="FadeRight-Effect">
										<PODetails id={props.details.po.id} poId={props.details.po.poId} invoiceId={id} multiPos={props.details.po}/>
									</div> : undefined
							}
							{
								getTab === 6 ?
									<div className='FadeRight-Effect'>
										<SupportTicket id={id} type="vendor-invoice" />
									</div>
									: null
							}
							{
								getTab === 7 ?
									<>
										{
											integrationData && Object.keys(integrationData).length ?
												<Integration
													type="vendor-invoice"
													reference={details.invoice.id}
													integrationData={integrationData}
													refresh={props.onReload}
												/>

												: null
										}
									</>
									: null
							}
							{
								getTab === 8 ?
									<div className='FadeRight-Effect'>
										<TwoBRecon gst2ASyncingForIrn={gst2ASyncingForIrn} id={id} details={details} />
									</div>
									: null
							}
							{
								getTab === 9 ?
									<div className='FadeRight-Effect'>
										<Contract id={details.tags && details.tags['contract.id']} details={details} />
									</div>
									: null
							}
							{
								getTab === 13 ?
									<div className='FadeRight-Effect'>
										<OcrDetails invoiceDeatails={details.invoice} />
									</div>
									: null
							}
							{
								getTab === 15 ?
									<div className='FadeRight-Effect'>
										<IMSDetails invoiceDeatails={details.invoice} />
									</div>
									: null
							}
							{
								getTab === 14 ?
									<div className='FadeRight-Effect'>
									   <Gin 
										poId={props.details.po.poId} 
										id={id}  
										ginInvoiceTagging={ginInvoiceTagging}
										ginDetails={details && details.gin} 
										reload={props.onReload}
									    />
									</div>
									: null
							}


							<div style={{ height: '50px' }} />
						</>}
			</div>


			<Modal
				title='Add Partial Payment'
				des="Fill up the details"
				close={() => {
					setPartial(false)
				}}
				show={partial}
				onSave={() => {
					let amount = +AMOUNT.current.value;
					let remarks = REMARK.current.value;


					if (!amount) {
						showToast({
							type: 'error',
							message: 'Please enter the amount'
						})
						return
					}
					if (!remarks) {
						showToast({
							type: 'error',
							message: "Please enter the remarks"
						})
						return;
					}


					let data = {
						amount,
						remarks,
						currency: details.invoice.currency,

					}

					post(`settlements/settlements/invoice/${id}/partial`, { ...data }, (e, r) => {
						if (r) {
							setPartial(false)
							props.onReload()	
							fetchSettlements(id)
							showToast({
								type: 'success',
								message: "Partial payment done successfully"
							})
						} else {
							handleError(e)
						}
					})

				}}
			>
				<FunctionalInput type="text" title="Amount" ref={AMOUNT} />
				<FunctionalInput type="text" title="Remarks" ref={REMARK} />

			</Modal>

			<Modal
				title='Recall Invoice'
				des="Enter a reason to recall it"
				close={() => {
					setRecall(false)
				}}
				show={recall}
				onSave={() => {
					let remarks = REMARKS1.current.value;

					if (!remarks) {
						showToast({
							type: 'error',
							message: "Please enter the remarks"
						})
						return;
					}


					let data = {
						remarks
					}

					post(`settlements/vendor/invoices/${id}/recall`, { ...data }, (e, r) => {
						if (r) {
							setRecall(false)
							fetchSettlements(id)
							props.onReload()
							setTab(1)
							showToast({
								type: 'success',
								message: "Invoice Recall  successfully"
							})
						} else {
							handleError(e)
						}
					})

				}}
			>
				<FunctionalInput type="text" title="Remarks" ref={REMARKS1} />

			</Modal>

			<Modal
				title='Untag Settlement'
				des="Confirm to untag"
				close={() => {
					setUntag(false)
				}}
				show={untag}
				hideButton={true}
				hideFooter={true}
			>
				<div className='modal-footer' style={{'margin':'0',padding:'0'}}>
					<div style={{
						background: "var(--primary-color)",
						width: "100%",
						border: "2px solid var(--primary-color)",
						padding: '12px 15px',
						textAlign: 'center',
					}} onClick={()=>{
						if(btnloading){
							return;
						}
						if(untag.ledgerId && id){
							setBtnLoading(true);
							post(`settlements/settlements/${untag.ledgerId}/invoice/${id}/unTagV2`, {}, (e, r) => {
								if (r) {
									setUntag(false)
									fetchSettlements(id)
									props.onReload()
									setTab(1)
									showToast({
										type: 'success',
										message: "Untag successfull"
									})
									setBtnLoading(false);
								} else {
									handleError(e)
									setBtnLoading(false);
								}
							})
						}
					}} className="save">
						{btnloading?<div style={{display:'flex',height:'inherit',justifyContent:'center',alignItems:'center'}}> <StateButton/> </div>: "Untag"}
					</div>
				</div>
			</Modal>

			<Modal
				title='Recall Partial Payment'
				des="Enter a reason to recall it"
				close={() => {
					setRecallPartial(false)
				}}
				show={recallPartial}
				onSave={() => {
					let remarks = REMARKS.current.value;

					if (!remarks) {
						showToast({
							type: 'error',
							message: "Please enter the remarks"
						})
						return;
					}


					let data = {
						remarks,
					}

					post(`settlements/settlements/${recallPartial.id}/cancel`, { ...data }, (e, r) => {
						if (r) {
							setRecallPartial(false)
							fetchSettlements(id)
							props.onReload()
							setTab(1)
							showToast({
								type: 'success',
								message: "Partial Payment Recall  successfully"
							})
						} else {
							handleError(e)
						}
					})

				}}
			>
				<FunctionalInput type="text" title="Remarks" ref={REMARKS} />
			</Modal>

			{
				ledger ?
					<ViewLedger
						id={ledger}
						onClose={() => {
							setLedger(false)
						}}
					/>
					: null
			}

			{
				decline && decline !== 0 ? <DropdownModal
					title="Decline Invoice"
					button="Decline"
					close={() => {
						setDecline(undefined)
					}}
					stateLoading={buttonLoading}
					dropdown="vendor-decline"
					onNext={val => {
						if (btnloading) {
							return;
						}
						setButtonLoading(true)
						if(details.type==="utility" && (details.status !== 'TAXATION_APPROVAL')){
							let id=(details && details.invoice && details.invoice.id)?details.invoice.id:"";
							axios.delete(`${getBaseUrl()}/settlements/vendor/utility/${id}?remarks=${val}`, {
									headers: {
										"content-type": "text/html"
									},

								}).then(s => {
									if(s) {
										showToast({
											type:'success',
											message:'Invoice declined successfully'
										})
										props.onReload();
										setDecline(undefined)
									}
								}).catch(handleError)
								.finally(() => setButtonLoading(false));
						}
						else{
							const API = details && (details.status === 'TAXATION_APPROVAL') ? 
							`/settlements/vendor/invoices/${decline}/declineTaxationApproval` 
							: `/settlements/vendor/invoices/${decline}`;

							axios.delete(`${getBaseUrl()}${API}?remarks=${val}`, {
								headers: {
									"content-type": "text/html"
								},
							}).then(s => {
								showToast({
									type: 'success',
									message: 'Invoice declined successfully'
								})
								setDecline(undefined)
								props.onReload();
							}).catch(handleError)
							.finally(() => setButtonLoading(false));
						}
					}}
				/> : null}
			 <Modal
				title='Withdraw Invoice'
				des="Enter a reason to Withdraw invoice"
				close={() => {
					setWithdraw(false)
				}}
				buttonName="Withdraw"
				show={withdraw}
				style={{
					save: {
					  height: "40px",
					  width: "100%",
					  display: "flex",
					  justifyContent: "center",
					  alignItems: "center",
					  backgroundColor: 'var(--red-color)',
					  borderColor: 'var(--red-color)'
					},
				  }}
				onSave={() => {
					let remarks = WITHDRAW_REMARK.current.value;
					if (!remarks) {
						showToast({
							type: 'error',
							message: "Please enter the remarks"
						})
						return;
					}

					let data = {
						remarks
					}

					post(`/vendor/invoicing/${id}/withdraw`, { ...data }, (e, r) => {
						if (r) {
							fetchSettlements(id)
							props.onReload()
							props.reloadInvoice &&  props.reloadInvoice()
							setTab(1)
							showToast({
								type: 'success',
								message: "Invoice Recall  successfully"
							})
							setWithdraw(false)
						} else {
							handleError(e)
						}
					})

				}}
			>
				<FunctionalInput type="text" title="Remarks" ref={WITHDRAW_REMARK} />
			</Modal>
			{repost ? 
			<Modal show={true}
				des=""
				buttonName="SAP Repost"
				style={{
					save: {
						padding: '8px 15px',
						width: '100%',
						textAlign: 'center'
					},
					close: {
						display: 'none'
					}
				}}
				title="SAP Re-post"
				close={() => {
					setRepost(false)
				}}
				onSave={onRepost}
				>
			<p>Are you sure to Repost Invoice ?</p>
		   </Modal>
		   : null }
			{revertBack && 
				<Modal
					title='Send Back Invoice'
					des="Enter a reason to revert back invoice"
					close={() => {
						setRevertBack(false)
					}}
					buttonName="Send Back"
					stateLoading={buttonLoading}
					show={true}
					style={{
						save: {
							height: "40px",
							width: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							backgroundColor: 'var(--primary-color)',
							borderColor: 'var(--primary-color)'
						},
					}}
					onSave={() => {
						let remarks = REVERT_REMARK.current.value;
						let approverKey = APPROVER.current.getValue();
						if (!remarks) {
							showToast({
								type: 'error',
								message: "Please enter the remarks"
							})
							return;
						}
						let data = {
							remarks,
							taskId: Number(revertBack)
						}

						if ((approverKey !== 'uploader') && (approverKey !== 'taxation')) {
							data["revertedToTaskId"] = approverKey ? Number(approverKey) : approverKey
						}
						if(approverKey==='taxation') {
							data["to_taxation"] =true
						}
                       const API = details && (details.status === 'TAXATION_APPROVAL') ? 
                         `/settlements/vendor/invoices/${revertBack}/sendBackTaxationApproval` 
                          : `/vendor/invoicing/${revertBack}/revertBack`;
                        setButtonLoading(true)
						post(`${API}`, { ...data }, (e, r) => {
							if (r) {
								showToast({
									type: 'success',
									message: "Invoice Sent Back successfully"
								})
								REVERT_REMARK.current.value = ''
								setRevertBack(undefined)
								props.onReload()
							} else {
								handleError(e)
							}
							setButtonLoading(false)
						})

					}}
				>
					<FloatSelect handleRef={ref => APPROVER.current = ref} items={approvalsList}
						title={"Select Approver"}
					/>
					<FunctionalInput type="text" title="Remarks" ref={REVERT_REMARK} />
				</Modal>
			}
			{submittingForm ?
				<Modal
					title='Submit Invoice'
					des="Enter a custom form details"
					close={() => {
						setSubmittingForm(false)
					}}
					buttonName="Approve"
					show={true}
					style={{
						save: {
							height: "40px",
							width: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							backgroundColor: 'var(--primary-color)',
							borderColor: 'var(--primary-color)'
						},
					}}
					onSave={() => {
						const hasError = InvoiceForm.some((item) => {
							if (!prefill[item.fieldId] &&
								item.dependentField &&
								item.dependentField.first === 'credit_days_breach' &&
								item.dependentField.second === 'Yes') {
								showToast({
									type: 'error',
									message: `${item.name} is required`
								});
								return true; 
							}
							return false;
						});
						
						if (!hasError) {
							approveModal();
						}
					 }}
				>
					{InvoiceForm.map(renderInvoiceCustomForm)}
				</Modal>
				: null}
				{ocrView && <ViewOcrMapping onClose={() => setViewOcr(undefined)} data={ocrView} />}
				{
				approveDiscountingModal && (
					<Modal
						show={approveDiscountingModal}
						close={() => {
							setApproveDiscountingModal(false);
						}}
						title="Approve Invoice Discounting"
						hideButton={true}
					>
						<p style={{ marginTop: '24px' }}>
							Are you sure you want to approve this invoice (<span style={{fontWeight: '600'}}>{approveDiscountingModal.owner.title} - {approveDiscountingModal.invoice.currency} {approveDiscountingModal.invoice.amount}</span>) for Invoice discounting?
						</p>
						<div style={{ width: '100%', display: 'flex-col' }}>
							<div className='div_outline' style={{ width: '100%', margin: "20px 0px" }}>
								{approveDetails(approveDiscountingModal)}
							</div>
							<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '16px', paddingRight: '8px', paddingLeft: '8px' }}>
								<button
									style={{
										backgroundColor: "var(--primary-color)",
										color: 'white',
										padding: '12px 20px',
										borderRadius: '6px',
										cursor: 'pointer',
										width: '48%',
										border: 'none'
									}}
									onClick={() => {
										if(approveDiscountingModal.invoice &&  approveDiscountingModal.invoice.id)
										handleApprove(approveDiscountingModal.invoice.id)}}
								>
									Confirm & Approve
								</button>


								<button
									style={{
										backgroundColor: "white",
										color: '#101828',
										padding: '12px 20px',
										borderRadius: '6px',
										cursor: 'pointer',
										width: '48%',
										outline: '2px solid #E2E2E2',
										border: 'none'
									}}
									onClick={() => setApproveDiscountingModal(null)}
								>
									Close
								</button>
							</div>
						</div>
					</Modal>
				)
			}
			{
				declineDiscountingModal && (
					<Modal
						show={declineDiscountingModal}
						close={() => {
							setDeclineDiscountingModal(null);
						}}
						title="Decline Invoice Discounting"
						hideButton={true}
					>
						<p style={{ marginTop: '24px', fontSize: '18px', lineHeight: '1.5' }}>
							Are you sure you want to decline this invoice ({declineDiscountingModal.owner.ownerName} - {declineDiscountingModal.currency} {declineDiscountingModal.amount}) for Invoice discounting?
						</p>
						<div style={{ width: '100%', display: 'flex-col' }}>
						<div style={{display: 'flex', alignItems: 'center'}}>
                    <FloatInput type="text" title="Enter Remarks" handleRef={ref => REMARK2.current = ref} />
                       </div>
							<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '16px', paddingRight: '8px', paddingLeft: '8px' }}>
								<button
									style={{
										backgroundColor: "#FB4448",
										color: 'white',
										padding: '12px 20px',
										borderRadius: '6px',
										cursor: 'pointer',
										width: '48%',
										border: 'none'
									}}
									onClick={() => {
										if(declineDiscountingModal.invoice && declineDiscountingModal.invoice.id)
										handleDecline(declineDiscountingModal.invoice.id)}}
								>
									Decline
								</button>


								<button
									style={{
										backgroundColor: "white",
										color: '#101828',
										padding: '12px 20px',
										borderRadius: '6px',
										cursor: 'pointer',
										width: '48%',
										outline: '2px solid #E2E2E2',
										border: 'none'
									}}
									onClick={() => setDeclineDiscountingModal(null)}
								>
									Close
								</button>
							</div>
						</div>
					</Modal>
				)
			}
			{withholdGstModal && (
				<Modal
					title='Withhold GST'
					des=""
					close={() => {
						setWithholdGstModal(false)
					}}
					buttonName="Withhold"
					show={withholdGstModal}
					stateLoading={buttonLoading}
					style={{
						save: {
							height: "40px",
							width: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							backgroundColor: 'var(--primary-color)',
							borderColor: 'var(--primary-color)'
						},
					}}
					onSave={() => {
						setButtonLoading(true)
						post(`/settlements/vendor/invoices/${id}/withHoldGst`, {}, (e, r) => {
							if (r) {
								showToast({
									type: 'success',
									message: "GST Withheld successfully"
								})
								onReload()
								setWithholdGstModal(false)
							} else {
								handleError(e)
							}
							setButtonLoading(false)
						})
					}}
					>
						<p>Are you sure you want to withhold GST?</p>
				</Modal>
			)}
			{partialPaymentModal &&
				<Modal
					title='Partial Payment Request'
					des="Enter the amount and remarks to send back the partial payment request for finance approval"
					close={() => {
						setPartialPaymentModal(false)
					}}
					buttonName="Make Request"
					stateLoading={buttonLoading}
					show={true}
					style={{
						save: {
							height: "40px",
							width: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							backgroundColor: 'var(--primary-color)',
							borderColor: 'var(--primary-color)'
						},
					}}
					onSave={() => {
						let amount = PARTIAL_AMOUNT.current.getValue();
						let remarks = PARTIAL_REMARK.current.value;
						if (!amount) {
							showToast({
								type: 'error',
								message: "Please enter the amount"
							})
							return;
						}
						if (!remarks) {
							showToast({
								type: 'error',
								message: "Please enter the remarks"
							})
							return;
						}
						let data = {
							remarks,
							amount: Number(amount)
						}
						setButtonLoading(true)
						post(`/settlements/settlements/invoice/${id}/partialPriorFinance`, { ...data }, (e, r) => {
							if (r) {
								showToast({
									type: 'success',
									message: "Partial Payment processed successfully"
								})
								PARTIAL_REMARK.current.value = ''
								PARTIAL_AMOUNT.current.setValue('')
								props.onReload()
								setPartialPaymentModal(false)
							} else {
								handleError(e)
							}
							setButtonLoading(false)
						})

					}}
				>
					<FloatInput type="number" title="Amount" handleRef={ref => PARTIAL_AMOUNT.current = ref} />
					<FunctionalInput type="text" title="Remarks" ref={PARTIAL_REMARK} />
				</Modal>
			}
			{lineItemsSelectModal?<LineItemsSelectModal 
				items={details.invoice.items}
				details={props && props.details ? props.details : {}}
				tenant={tenant}
				id={id}
				onReload={onReload}
				close={() => {setLineItemsSelectModal(false)}}/>:null}
		</SidePane>
		
	)
}